(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Api/ApiKeyList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul class=\"datasets\">\n";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "keys")) > 0) {
output += "\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "keys");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("key", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <li data-name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n            <span class=\"dataset-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "</span>\n            <div class=\"dataset-actions\">\n                <a href=\"#\" class=\"curriculog-widget add-widget\" title=\"Generate\"></a>\n                <a href=\"#\" class=\"curriculog-widget delete-widget\" title=\"Deprecate\"></a>\n            </div>\n            <div id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "-access-token-value\" class='access-token-value'></div>\n        </li>\n    ";
;
}
}
frame = frame.pop();
output += "\n";
;
}
else {
output += "\n    <li>No secret keys have been created for this user.</li>\n";
;
}
output += "\n</ul>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Api/ApiSecretManager.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id='key-manager' class='summary-content'>\n<fieldset>\n    <div class='summary-steps-heading'>API Key Manager</div>\n\n    <p class='summary-steps-directions'>Please give all keys a short name describing their intended use.  When deprecating a key, all tokens generated using that key will also be immediately deprecated.  Otherwise tokens will expire 25 hours after they were generated.  Choosing descriptive names will help make it more difficult to accidentally deprecate the wrong key.</p>\n\n    <div>\n        <button type=\"button\" id=\"create-secret-key\" class=\"create-secret-key\" name=\"create-secret-key\" value=\"\" class=\"form-button\">\n            Create a New Key\n        </button>\n        <div class=\"secret-key-name\">\n            <label>Key Name</label>\n            <input type=\"text\" name=\"keyName\" id=\"secret-key-name\" value=\"\">\n            <span id='keyName-errors' class='error'></span>\n        </div>\n    </div>\n\n    <div class='summary-steps-heading'>Existing Keys</div>\n    <div id='api-key-list'></div>\n\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Api/ApiSettingsManager.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id='test' class='summary-content'>\n    <fieldset>\n        <div class=\"summary-steps-heading\">API Settings</div>\n\n        <label>API Access</label>\n        <select id='api-enabled' data-setting-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "enabledSetting")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "enabledSetting")),"value", env.opts.autoescape) == "1") {
output += "\n                <option value=\"1\" selected>Enabled</option>\n                <option value='0'>Disabled</option>\n            ";
;
}
else {
output += "\n                <option value='1'>Enabled</option>\n                <option value='0' selected>Disabled</option>\n            ";
;
}
output += "\n        </select>\n\n        <br />\n\n        <button type=\"button\" id=\"save-api-settings\" name=\"save-api-settings\" value=\"\" class=\"form-button\">\n            <span>Save API Settings</span>\n        </button>\n\n        <button type=\"button\" id=\"cancel-api-settings\" name=\"cancel-api-settings\" value=\"\" class=\"form-button\">\n            <span>Cancel API Settings</span>\n        </button>\n    </fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Default/dropdownItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<option value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "value"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabled"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selected"), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Dialog/roleImpact.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<p class=\"text-left-align\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "num_steps"), env.opts.autoescape);
output += " step";
if(runtime.contextOrFrameLookup(context, frame, "num_steps") > 1) {
output += "s";
;
}
output += " in ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "num_proposals"), env.opts.autoescape);
output += " proposal";
if(runtime.contextOrFrameLookup(context, frame, "num_proposals") > 1) {
output += "s";
;
}
output += " will be affected by ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "action"), env.opts.autoescape);
output += " this role.</p>\n\n";
if(runtime.contextOrFrameLookup(context, frame, "num_current_steps") > 0) {
output += "\n<p class=\"text-left-align\">The current step of the following proposals will be affected. Each proposal listed will have its current step restarted upon confirming this dialog. Proposals marked with a <img src=\"/images/icons/flat/warning.png\" /> will have no participants after the current step is restarted. You will need to add a user to the role to allow further progress for these proposals.</p>\n\n<ul class=\"dialog-sublist list-with-warnings\">\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "current_step_impact");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("impact", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    <li";
if(runtime.memberLookup((t_4),"hasEmptyStep", env.opts.autoescape)) {
output += " class=\"warning\"";
;
}
output += ">\n        ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"proposalName", env.opts.autoescape), env.opts.autoescape);
output += "\n    </li>\n    ";
;
}
}
frame = frame.pop();
output += "\n</ul>\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "num_future_steps") > 0) {
output += "\n<p class=\"text-left-align\">\n";
if(runtime.contextOrFrameLookup(context, frame, "num_current_steps") > 0) {
output += "\nThe remaining proposals will be affected on a future step.\n";
;
}
else {
output += "\nThe following proposals will be affected on a future step.\n";
;
}
output += "\n\nProposals marked with a <img src=\"/images/icons/flat/warning.png\" /> will have no participants when the proposal reaches the affected step. You will need to add a user to the role to allow further progress for these proposals.</p>\n\n<ul class=\"dialog-sublist list-with-warnings\">\n    ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "future_step_impact");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("impact", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n    <li";
if(runtime.memberLookup((t_8),"hasEmptyStep", env.opts.autoescape)) {
output += " class=\"warning\"";
;
}
output += ">\n        ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"proposalName", env.opts.autoescape), env.opts.autoescape);
output += "\n    </li>\n    ";
;
}
}
frame = frame.pop();
output += "\n</ul>\n";
;
}
output += "\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Dialog/supportForm.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"support-form\">\n\t<p class=\"login-form-p\">If you need assistance using Curriculog or have encountered a system error,\n\t\tplease fill in the following support form. Your system administrators can assist you.<br><br>\n\t</p>\n\t<ul>\n\t\t<li class=\"clearfix\">\n\t\t\t<label for=\"support-question\">Question*</label>\n\t\t\t<div class=\"dialog-field\">\n\t\t\t\t<input name=\"support-question\" id=\"support-question\" type=\"text\" value=\"\" \n\t\t\t\t\tplaceholder=\"Briefly describe your question\">\n\t\t\t</div>\n\t\t</li>\n\t\t<li class=\"clearfix\">\n\t\t\t<label for=\"support-details\">Details*</label>\n\t\t\t<div class=\"dialog-field\">\n\t\t\t\t<textarea name=\"support-details\" id=\"support-details\" \n\t\t\t\t\tplaceholder=\"Fill in the details here. Please try to be as specific as possible.\"></textarea>\n\t\t\t</div>\n\t\t</li>\n\t\t<li class=\"clearfix\">\n\t\t\t<label for=\"support-url\">Url</label>\n\t\t\t<div class=\"dialog-field\">\n\t\t\t\t<input name=\"support-url\" id=\"support-url\" type=\"text\" value=\"\" \n\t\t\t\t\tplaceholder=\"If you encountered an error, include the page url\">\n\t\t\t</div>\n\t\t</li>\n\t\t<li class=\"clearfix\">\n\t\t\t<br><br>\n\t\t\t<label for=\"support-name\">Name*</label>\n\t\t\t<div class=\"dialog-field\">\n\t\t\t\t<input name=\"support-name\" id=\"support-name\" type=\"text\" value=\"\" \n\t\t\t\t\tplaceholder=\"Your full name\">\n\t\t\t</div>\n\t\t</li>\n\t\t<li class=\"clearfix\">\n\t\t\t<label for=\"support-email\">Email*</label>\n\t\t\t<div class=\"dialog-field\">\n\t\t\t\t<input name=\"support-email\" id=\"support-email\" type=\"text\" value=\"\" \n\t\t\t\t\tplaceholder=\"Your email\">\n\t\t\t</div>\n\t\t</li>\n\t</ul>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/flyoutTitle.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n<div class=\"summary-content-title\">\n  <h2 class=\"summary-title\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "title")), env.opts.autoescape);
output += "</h2>\n  <button class=\"curriculog-widget close-widget close-summary\"><strong class=\"screen-reader-text\">Close</strong></button>\n</div>\n";
;
}
else {
output += "\n<h3 class=\"summary-title\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "title")), env.opts.autoescape);
output += "</h3>\n";
;
}
output += "\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageEntity.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"summary-content\">\n<fieldset id=\"entity-details-form\">\n\t<legend class=\"summary-steps-heading\">Manage Entity</legend>\n\t<input name=\"entity-details-id\" id=\"entity-details-id\" type=\"hidden\" value=\"1\">\n\n\t<label for=\"entity-details-name\">Entity Name</label>\n\t<input type=\"text\" name=\"entity-details-name\" id=\"entity-details-name\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entity")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\n\t<label for=\"entity-details-type\">Entity Type</label>\n\n\t<fieldset>\n\t\t<div class=\"legend label\">Entity Status</div>\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entity")),"status", env.opts.autoescape) == "active") {
output += "\n\t\t\t<input type=\"checkbox\" name=\"entity-details-status\" id=\"entity-details-status\" class=\"inline-input\" value=\"active\" checked=\"checked\">\n\t\t";
;
}
else {
output += "\n\t\t\t<input type=\"checkbox\" name=\"entity-details-status\" id=\"entity-details-status\" class=\"inline-input\" value=\"active\">\n\t\t";
;
}
output += "\n\t\t<label for=\"entity-details-status\" class=\"checkbox\">Active</label>\n\t</fieldset>\n\n\t<button type=\"button\" id=\"entity-details-update\" name=\"entity-details-update\" value=\"\" class=\"form-button\">\n\t\t<span>Update</span>\n\t</button>\n\t<button type=\"button\" id=\"entity-details-reset\" name=\"entity-details-reset\" value=\"\" class=\"form-button\">\n\t\t<span>Reset</span>\n\t</button>\n\t<button type=\"button\" id=\"entity-details-delete\" name=\"entity-details-delete\" value=\"\" class=\"form-button\" disabled=\"disabled\">\n\t\t<span>Delete Entity</span>\n\t</button>\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageParents.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"summary-content\">\n<fieldset>\n\t<legend class=\"summary-steps-heading\">Manage Parents</legend>\n\t<label for=\"entity-parents-available\">Entity</label>\n\n\t<button type=\"button\" id=\"entity-parents-add\" name=\"entity-parents-add\" value=\"\" class=\"form-button\">\n\t\t<span>Add Parent</span>\n\t</button>\n\n\t<br clear=\"all\">\n\t<br clear=\"all\">\n\n\t<div class=\"label\">Parents</div>\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageRoles.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"roles-for-entity-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "entityID"), env.opts.autoescape);
output += "\" class=\"summary-content\">\n<fieldset>\n\t<legend class=\"summary-steps-heading\">Manage Roles</legend>\n\t<div id=\"entity-roles-form\" class=\"dialog-field dialog-subform\">\n\n\t\t<input type=\"hidden\" name=\"roleId\" id=\"entity-role-id\" value=\"\">\n\n\t\t<label for=\"entity-role-name\">Role Name</label>\n\t\t<input type=\"text\" name=\"roleName\" id=\"entity-role-name\" value=\"\">\n\n\t\t<label for=\"entity-roles-available\">Role Type</label>\n\n\t\t<label for=\"entity-role-committee\">Committee</label>\n\t\t<input type=\"hidden\" id=\"entity-role-original-committee\" name=\"original-committee\">\n\n\t\t<button type=\"button\" id=\"entity-role-add\" name=\"entity-role-add\" value=\"\" class=\"form-button\">\n\t\t\t<span>Create New Role</span>\n\t\t</button>\n\t\t<button type=\"button\" id=\"entity-role-update\" name=\"entity-role-add\" value=\"\" class=\"form-button\" style=\"display:none\" disabled=\"disabled\">\n\t\t\t<span>Update</span>\n\t\t</button>\n\t\t<button type=\"button\" id=\"entity-role-cancel\" name=\"entity-role-cancel\" value=\"\" class=\"form-button\">\n\t\t\t<span>Reset</span>\n\t\t</button>\n\n\t</div>\n\n\t<br clear=\"all\">\n\n\t<div class=\"label\">Roles</div>\n\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageRolesBasic.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"manage-role-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "roleID"), env.opts.autoescape);
output += "\" class=\"summary-content\">\n<fieldset>\n\t<legend class=\"summary-steps-heading\">Manage Role</legend>\n\t<div id=\"entity-roles-form\" class=\"dialog-field dialog-subform\">\n\n\t\t<input type=\"hidden\" name=\"roleId\" id=\"entity-role-id\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "role")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\n\t\t<label for=\"entity-role-name\">Role Name</label>\n\t\t<input type=\"text\" name=\"roleName\" id=\"entity-role-name\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "role")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\n\t\t<label for=\"entity-roles-available\">Role Type</label>\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "canDelete") == false) {
output += "\n\t\t\t<input type=\"text\" name=\"roleTypeName\" id=\"role-type-name\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "roleTypeName"), env.opts.autoescape);
output += "\" disabled=\"disabled\">\n\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "committeeName")) {
output += "\n\t\t\t\t<label for=\"entity-role-committee\">Committee</label>\n\t\t\t\t<input type=\"hidden\" id=\"entity-role-original-committee\" name=\"original-committee\">\n\t\t\t\t<input type=\"text\" name=\"committeeName\" id=\"committee-name\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "committeeName"), env.opts.autoescape);
output += "\" disabled=\"disabled\">\n\t\t\t";
;
}
output += "\n\t\t";
;
}
else {
output += "\n\t\t\t<label for=\"entity-role-committee\">Committee</label>\n\t\t";
;
}
output += "\n\n\t\t<button type=\"button\" id=\"entity-role-update\" name=\"entity-role-add\" value=\"\" class=\"form-button\">\n\t\t\t<span>Update</span>\n\t\t</button>\n\t\t<button type=\"button\" id=\"entity-role-cancel\" name=\"entity-role-cancel\" value=\"\" class=\"form-button\">\n\t\t\t<span>Reset</span>\n\t\t</button>\n\t\t<button type=\"button\" id=\"entity-role-delete\" name=\"entity-role-delete\" value=\"\" class=\"form-button\" disabled=\"disabled\">\n\t\t\t<span>Delete Role</span>\n\t\t</button>\n\n\t</div>\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageUser.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"summary-content\">\n<fieldset>\n\t<div id=\"user-details-form\">\n\t\t<legend class=\"summary-steps-heading\">Personal Information</legend>\n\t\t<input type=\"hidden\" name=\"user-details-id\" id=\"user-details-id\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\n\t\t<label for=\"user-details-firstName\">First Name</label>\n\t\t<input type=\"text\" name=\"firstName\" id=\"user-details-firstName\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"first_name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t<label for=\"user-details-lastName\">Last Name</label>\n\t\t<input type=\"text\" name=\"lastName\" id=\"user-details-lastName\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"last_name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t<label for=\"user-details-email\">Email</label>\n\t\t<input type=\"text\" name=\"email\" id=\"user-details-email\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"email", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t<fieldset>\n\t\t\t<legend class=\"label checkbox\" for=\"user-details-isRemote\">Remote Access</legend>\n\t\t\t<input type=\"checkbox\" class=\"checkbox\" name=\"isRemote\" id=\"user-details-isRemote\" value=\"active\">\n\t\t\t<label for=\"user-details-isRemote\" class=\"checkbox\">User authenticates with your institution's Directory Service</label>\n\t\t</fieldset>\n\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"is_remote", env.opts.autoescape) == 1) {
output += "\n\t\t<div class=\"remote-options\" style=\"display: block;\">\n\t\t";
;
}
else {
output += "\n\t\t<div class=\"remote-options\" style=\"display: none;\">\n\t\t";
;
}
output += "\n\t\t\t<label for=\"user-details-password\">Password</label>\n\t\t\t<div class=\"input checkbox\" style=\"height: 28px;\"><span class=\"msg\">Password is stored in your institution's Directory Service.</span></div>\n\n\t\t\t<label for=\"user-details-userName\">User ID</label>\n\t\t\t<input type=\"text\" name=\"userName\" id=\"user-details-userName\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"user_name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t</div>\n\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"is_remote", env.opts.autoescape) == 1) {
output += "\n\t\t<div class=\"local-options active\" style=\"display: none;\">\n\t\t";
;
}
else {
output += "\n\t\t<div class=\"local-options active\" style=\"display: block;\">\n\t\t";
;
}
output += "\n\t\t\t<label for=\"user-details-password\">Password</label>\n\t\t\t<div class=\"input\"><a class=\"curriculog-widget edit-widget change-password\"><strong>Change Password</strong></a></div>\n\t\t</div>\n\n\t\t<fieldset>\n\t\t\t<legend class=\"label checkbox\" for=\"user-details-status\">Status</legend>\n\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"status", env.opts.autoescape) == "active") {
output += "\n\t\t\t\t<input type=\"checkbox\" class=\"checkbox\" name=\"status\" id=\"user-details-status\" value=\"active\" checked=\"checked\">\n\t\t\t";
;
}
else {
output += "\n\t\t\t\t<input type=\"checkbox\" class=\"checkbox\" name=\"status\" id=\"user-details-status\" value=\"active\">\n\t\t\t";
;
}
output += "\n\t\t\t<label for=\"user-details-status\" class=\"checkbox\">Active</label>\n\t\t</fieldset>\n\n\t\t<button type=\"button\" id=\"save-user\" name=\"save-user\" value=\"\" class=\"form-button\"><span>Save Personal Information</span></button>\n\t\t<button type=\"button\" id=\"cancel-user\" name=\"cancel-user\" value=\"\" class=\"form-button\"><span>Cancel</span></button>\n\t\t<button type=\"button\" id=\"delete-user\" name=\"delete-user\" value=\"\" class=\"form-button\"><span>Delete User</span></button>\n\n\t</div>\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageUserRoles.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"summary-content\">\n\t<h4 class=\"summary-steps-heading\">Manage Roles</h4>\n\t<fieldset>\n\t\t<div id=\"entity-parents-form\">\n\t\t\t<label for=\"role-for-entity\">Entity</label>\n\n\t\t\t<label for=\"entity-roles-available\">Roles</label>\n\n\t\t\t<button type=\"button\" id=\"add-role\" name=\"add-role\" value=\"Add Role\" class=\"form-button\">\n\t\t\t\t<span>Add Role</span>\n\t\t\t</button>\n\t\t</div>\n\n\t\t<br clear=\"all\">\n\n\t\t<div class=\"label\">Chosen Roles</div>\n\n\t\t<br clear=\"all\">\n\t\t<br clear=\"all\">\n\n\t\t<div class=\"label\">Committees</div>\n\t</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/manageUserRolesBasic.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"summary-content\">\n<fieldset>\n\t<legend class=\"summary-steps-heading\">Manage User Role</legend>\n\t<div id=\"user-role-form\" class=\"dialog-field dialog-subform\">\n\n\t\t<label for=\"entity-role-name\">User Name</label>\n\t\t<input type=\"text\" name=\"userName\" id=\"user-name\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userName"), env.opts.autoescape);
output += "\" disabled=\"disabled\">\n\n\t\t<label for=\"entity-role-name\">Role Name</label>\n\t\t<input type=\"text\" name=\"roleName\" id=\"entity-role-name\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "roleName"), env.opts.autoescape);
output += "\" disabled=\"disabled\">\n\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "committeeName")) {
output += "\n\t\t\t<label for=\"entity-role-committee\">Committee</label>\n\t\t\t<input type=\"text\" name=\"committeeName\" id=\"entity-role-name\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "committeeName"), env.opts.autoescape);
output += "\" disabled=\"disabled\">\n\n\t\t\t<fieldset class=\"agenda-admin-checkbox\">\n\t\t\t\t<legend class=\"label\">Agenda Admin</legend>\n\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "agendaAdmin")) {
output += "\n\t\t\t\t\t<input type=\"checkbox\" name=\"agenda-admin\" id=\"agenda-admin\" class=\"inline-input\" value=\"active\" checked=\"checked\">\n\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t<input type=\"checkbox\" name=\"agenda-admin\" id=\"agenda-admin\" class=\"inline-input\" value=\"active\">\n\t\t\t\t";
;
}
output += "\n\t\t\t</fieldset>\n\t\t";
;
}
output += "\n\n\n\t\t<button type=\"button\" id=\"user-role-swap\" name=\"user-role-swap\" value=\"\" class=\"form-button\">\n\t\t\t<span>Swap User</span>\n\t\t</button>\n\t\t<button type=\"button\" id=\"user-role-delete\" name=\"user-role-swap\" value=\"\" class=\"form-button\" disabled=\"disabled\">\n\t\t\t<span>Remove User From Role</span>\n\t\t</button>\n\t</div>\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/userPermissions.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<fieldset>\n\t<legend class=\"summary-steps-subheading clearfix\">Permissions</legend>\n\n\t";
if(runtime.contextOrFrameLookup(context, frame, "permissions_originate_proposals") == 1) {
output += "\n\t\t<input type=\"checkbox\" name=\"permissionsOriginateProposals\" id=\"permissions_originate_proposals\" value=\"1\" checked=\"\">\n\t";
;
}
else {
output += "\n\t\t<input type=\"checkbox\" name=\"permissionsOriginateProposals\" id=\"permissions_originate_proposals\" value=\"1\">\n\t";
;
}
output += "\n\t<label for=\"permissions_originate_proposals\" class=\"checkbox\">Can Originate Proposals</label>\n\n\t";
if(runtime.contextOrFrameLookup(context, frame, "permissions_import_export") == 1) {
output += "\n\t\t<input type=\"checkbox\" name=\"permissionsImportExport\" id=\"permissions_import_export\" value=\"1\" checked=\"\">\n\t";
;
}
else {
output += "\n\t\t<input type=\"checkbox\" name=\"permissionsImportExport\" id=\"permissions_import_export\" value=\"1\">\n\t";
;
}
output += "\n\t<label for=\"permissions_import_export\" class=\"checkbox\">Can Import</label>\n\n\t";
if(runtime.contextOrFrameLookup(context, frame, "admin") == 1) {
output += "\n\t\t<input type=\"checkbox\" name=\"admin\" id=\"admin\" value=\"admin\" checked=\"\">\n\t";
;
}
else {
output += "\n\t\t<input type=\"checkbox\" name=\"admin\" id=\"admin\" value=\"admin\">\n\t";
;
}
output += "\n\t<label for=\"admin\" class=\"checkbox\">System Administrator</label>\n</fieldset>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/userPreferences.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<fieldset>\n\t<legend class=\"summary-steps-subheading clearfix\">User Preferences</legend>\n\n\t<label for=\"user_settings_originator_messages\"> Originator</label>\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user_settings_originator_messages")),"preference", env.opts.autoescape) == "admin") {
output += "\n\t\t<select name=\"userSettingsOriginatorMessages\" id=\"user_settings_originator_messages\">\n\t";
;
}
else {
output += "\n\t\t<select name=\"userSettingsOriginatorMessages\" id=\"user_settings_originator_messages\" disabled=\"\">\n\t";
;
}
output += "\n\t\t<option value=\"commentsOnlyUserProposals\">Get messages for comments only for user&#39;s proposals</option>\n\t\t<option value=\"commentsEditsOnlyUserProposals\">Get messages for comments and edits only for user&#39;s proposals</option>\n\t\t<option value=\"userProposals\">Get all messages for user&#39;s proposals</option>\n\t</select>\n\n\t<label for=\"user_settings_email_options\"> Email Options</label>\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user_settings_email_options")),"preference", env.opts.autoescape) == "admin") {
output += "\n\t\t<select name=\"userSettingsEmailOptions\" id=\"user_settings_email_options\">\n\t";
;
}
else {
output += "\n\t\t<select name=\"userSettingsEmailOptions\" id=\"user_settings_email_options\" disabled=\"\">\n\t";
;
}
output += "\n\t\t<option value=\"weeklyDigest\">Weekly Email Digest</option>\n\t\t<option value=\"MWFDigest\">M W F Email Digest</option>\n\t\t<option value=\"TRDigest\">T TH Email Digest</option>\n\t\t<option value=\"dailyDigest\">Daily Email Digest</option>\n\t\t<option value=\"individualEmails\">All Emails</option>\n\t</select>\n\n\t<label for=\"user_settings_process_send_messages\"> Process</label>\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user_settings_process_send_messages")),"preference", env.opts.autoescape) == "admin") {
output += "\n\t\t<select name=\"userSettingsProcessSendMessages\" id=\"user_settings_process_send_messages\">\n\t";
;
}
else {
output += "\n\t\t<select name=\"userSettingsProcessSendMessages\" id=\"user_settings_process_send_messages\" disabled=\"\">\n\t";
;
}
output += "\n\t\t<option value=\"steps\">Send messages for the steps in which I am involved only</option>\n\t\t<option value=\"proposals\">Send messages for proposals in which I am involved only</option>\n\t</select>\n\n\t<label for=\"approval_process_signature_steps\" class=\"disabled\"> Signature Steps</label>\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "approval_process_signature_steps")),"preference", env.opts.autoescape) == "admin") {
output += "\n\t\t<select name=\"approvalProcessSignatureSteps\" id=\"approval_process_signature_steps\">\n\t";
;
}
else {
output += "\n\t\t<select name=\"approvalProcessSignatureSteps\" id=\"approval_process_signature_steps\" disabled=\"\">\n\t";
;
}
output += "\n\t\t<option value=\"paperSignatures\">Upload paper signatures for signature steps</option>\n\t\t<option value=\"electronicPin\">Use Electronic PINS for signature steps</option>\n\t</select>\n\n\t<label for=\"approval_process_signature_steps_pin\"> Signature Pin</label>\n\t<div class=\"input\">\n\t\t<a class=\"curriculog-widget edit-widget change-pin \" href=\"#\">\n\t\t\t<strong>Change Pin</strong>\n\t\t</a>\n\t</div>\n\n</fieldset>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyFlyout/userRights.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"summary-content\">\n<fieldset>\n\t<legend class=\"summary-steps-heading\">User Rights</legend>\n\t<div id=\"user-settings-form\">\n\t\t<button type=\"button\" id=\"save-settings\" name=\"save-settings\" value=\"\" class=\"form-button\"><span>Save Preferences</span></button>\n\t\t<button type=\"button\" id=\"cancel-settings\" name=\"cancel-settings\" value=\"\" class=\"form-button\"><span>Cancel</span></button>\n\t</div>\n</fieldset>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/committeeList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"committees-chosen-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "\" class=\"itemlist committees\">\n\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("committee", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t<li class=\"committee\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" data-admin-count=\"2\" data-user-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "\">\n\n\t\t\t<div class=\"actions-agenda\">\n\t\t\t";
if(runtime.memberLookup((t_4),"isAgendaAdmin", env.opts.autoescape)) {
output += "\n\t\t\t\t\t<input type=\"checkbox\" name=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-committee-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "-admin\" id=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-committee-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "-admin\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"committee-add-agenda-admin\" checked=\"checked\">\n\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t<input type=\"checkbox\" name=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-committee-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "-admin\" id=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-committee-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "-admin\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"committee-add-agenda-admin\">\n\t\t\t";
;
}
output += "\n\t\t\t\t<label for=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-committee-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "-admin\">\n\t\t\t\t\tAgenda Administrator\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t</li>\n\t";
;
}
}
frame = frame.pop();
output += "\n</ul>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/emptyHierarchy.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul class=\"hierarchy-list\">\n\t<li class=\"no-summary\" id=\"detail-0\">\n\t\t<h3 class=\"list-name no-results\">\n\t\t\tNo Results Found\n\t\t</h3>\n\t</li>\n</ul>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/entityListItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li id=\"relationship-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "relationship")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"item type-entity open-summary level-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth"), env.opts.autoescape);
output += "\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  <div class=\"item-wrapper\" style=\"padding-left:";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 1.75, env.opts.autoescape);
output += "rem;\">\n  ";
;
}
else {
output += "\n\t<div class=\"item-wrapper\" style=\"padding-left:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth") * 30, env.opts.autoescape);
output += "px\">\n  ";
;
}
output += "\n\t\t<div class=\"item-actions\">\n\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget edit-item\" title=\"Edit Entity\"></a>\n\t\t</div>\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "numEntityRoles") > 0) {
output += "\n      ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      <div class=\"curriculog-widget expand-widget toggle-sublist\" style=\"width: ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 1.75, env.opts.autoescape);
output += "rem; margin-left:-";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 1.75, env.opts.autoescape);
output += "rem;\"></div>\n      ";
;
}
else {
output += "\n      <div class=\"curriculog-widget expand-widget toggle-sublist\"></div>\n      ";
;
}
output += "\n\t\t";
;
}
else {
output += "\n      ";
if(!runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n\t\t\t&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n      ";
;
}
output += "\n\t\t";
;
}
output += "\n\t\t<div class=\"entity-name\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "</div>\n\t</div>\n\n\t<ul class=\"item-roles role-list\"></ul>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/hierarchyDropdownItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<option value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entity")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" data-depth=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth"), env.opts.autoescape);
output += "\" data-children=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "hasChildren"), env.opts.autoescape);
output += "\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabled"), env.opts.autoescape);
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selected"), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "depthOutput")), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entity")),"name", env.opts.autoescape), env.opts.autoescape);
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inactiveText"), env.opts.autoescape);
output += "</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/parentList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"entity-parents\" class=\"itemlist entities\">\n\t";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "parents")) <= 0) {
output += "\n\t\t<li class=\"none\">You have not selected any parents.</li>\n\t";
;
}
else {
output += "\n\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "parents");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("parent", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t\t<li>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t\t\t<input type=\"hidden\" name=\"id\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t\t<div class=\"actions\">\n\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "canDelete")) {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget entity-parent-remove\" title=\"Remove Parent\"></a>\n\t\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget entity-parent-remove disabled\" title=\"Parent cannot be deleted\"></a>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t";
;
}
}
frame = frame.pop();
output += "\n\t";
;
}
output += "\n</ul>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/roleList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"entity-roles\" class=\"itemlist roles\">\n\t";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "items")) <= 0) {
output += "\n\t\t<li class=\"none\">You have not selected any roles.</li>\n\t";
;
}
else {
output += "\n\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("role", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n      ";
if(runtime.memberLookup((t_4),"committee_id", env.opts.autoescape)) {
output += "\n      <li class=\"has-committee\">\n      ";
;
}
else {
output += "\n\t\t\t<li>\n      ";
;
}
output += "\n\t\t\t\t<input type=\"hidden\" name=\"id\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t\t<input type=\"hidden\" name=\"name\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t\t<input type=\"hidden\" name=\"roleTypeID\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"role_type_id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t\t<input type=\"hidden\" name=\"committeeID\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"committee_id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t\t<div class=\"actions\">\n\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget entity-role-edit\" title=\"Edit Role\"></a>\n\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entityRoleCanDeletes")),runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape)) {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget entity-role-remove\" title=\"Remove Role\"></a>\n\t\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget entity-role-remove disabled\" title=\"Role cannot be deleted\"></a>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t\t";
if(runtime.memberLookup((t_4),"committee_id", env.opts.autoescape)) {
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n          <br>\n          <small class=\"entity-role-committee\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"committee_name", env.opts.autoescape), env.opts.autoescape);
output += "</small>\n        ";
;
}
else {
output += "\n\t\t\t\t<img class=\"entity-role-committee tip\" src=\"/images/icons/flat/committees.png\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"committee_name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n        ";
;
}
output += "\n\t\t\t";
;
}
output += "\n\t\t\t</li>\n\t\t";
;
}
}
frame = frame.pop();
output += "\n\t";
;
}
output += "\n</ul>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/roleListItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li id=\"role-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" class=\"item type-role open-summary\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  <div class=\"item-wrapper\" style=\"padding-left:";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 3.5, env.opts.autoescape);
output += "rem;\">\n  ";
;
}
else {
output += "\n\t<div class=\"item-wrapper\" style=\"padding-left:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth") * 30 + 25, env.opts.autoescape);
output += "px\">\n  ";
;
}
output += "\n\t\t<div class=\"item-actions\">\n\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget edit-item\" title=\"Edit Role\"></a>\n\t\t</div>\n\t\t";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "userRoles")) > 0) {
output += "\n      ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      <div class=\"curriculog-widget expand-widget toggle-sublist\" style=\"width: ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 3.5, env.opts.autoescape);
output += "rem; margin-left:-";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 3.5, env.opts.autoescape);
output += "rem;\"></div>\n      ";
;
}
else {
output += "\n\t\t\t<div class=\"curriculog-widget expand-widget toggle-sublist\"></div>\n      ";
;
}
output += "\n\t\t";
;
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "committee")) {
output += "\n    <div class=\"role-name has-committee\">\n    ";
;
}
else {
output += "\n\t\t<div class=\"role-name\">\n    ";
;
}
output += "\n      ";
if(runtime.contextOrFrameLookup(context, frame, "committee") && runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      <div>\n      ";
;
}
output += "\n      ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "committee")) {
output += "\n      ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      <small class=\"entity-role-committee\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "committee")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</small>\n      </div>\n      ";
;
}
else {
output += "\n\t\t\t<img class=\"entity-role-committee tip\" src=\"/images/icons/flat/committees.png\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "committee")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n      ";
;
}
output += "\n\t\t";
;
}
output += "\n\t\t</div>\n\t</div>\n\n\t<ul class=\"item-users user-list\"></ul>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/userRoleList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"roles-choosen-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "\" class=\"itemlist roles\">\n\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("role", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    ";
if(runtime.memberLookup((t_4),"committee", env.opts.autoescape)) {
output += "\n    <li id=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-role-saved-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"has-committee\">\n    ";
;
}
else {
output += "\n\t\t<li id=\"user-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userID"), env.opts.autoescape);
output += "-role-saved-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n    ";
;
}
output += "\n\t\t\t<input type=\"hidden\" name=\"id\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t<input type=\"hidden\" name=\"name\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t<input type=\"hidden\" name=\"entity\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"entityName", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t";
if(runtime.memberLookup((t_4),"committee", env.opts.autoescape)) {
output += "\n\t\t\t\t<input type=\"hidden\" name=\"committee-name\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"committee", env.opts.autoescape)),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t\t";
;
}
else {
output += "\n\t\t\t\t<input type=\"hidden\" name=\"committee-name\" value=\"\">\n\t\t\t";
;
}
output += "\n\t\t\t<div class=\"actions\">\n\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget user-role-remove type-replace\" title=\"Replace User for Role\"></a>\n\t\t\t</div>\n\n  \t\t";
if(runtime.memberLookup((t_4),"committee", env.opts.autoescape) && runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      <div>\n      ";
;
}
output += "\n\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\n\t\t\t";
if(runtime.memberLookup((t_4),"committee", env.opts.autoescape)) {
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n          <div>\n          <small class=\"entity-role-committee\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"committee", env.opts.autoescape)),"name", env.opts.autoescape), env.opts.autoescape);
output += "</small>\n          </div>\n        ";
;
}
else {
output += "\n\t\t\t\t<img class=\"entity-role-committee tip\" src=\"/images/icons/flat/committees.png\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"committee", env.opts.autoescape)),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n        ";
;
}
output += "\n\t\t\t";
;
}
output += "\n\t\t</li>\n\t";
;
}
}
frame = frame.pop();
output += "\n</ul>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyList/userRoleListItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li id=\"userRole-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "userRole")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"item type-user open-summary\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  <div class=\"item-wrapper\" style=\"padding-left:";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "depth") * 1.75) + 5, env.opts.autoescape);
output += "rem;\">\n  ";
;
}
else {
output += "\n\t<div class=\"item-wrapper\" style=\"padding-left:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth") * 30 + 70, env.opts.autoescape);
output += "px\">\n  ";
;
}
output += "\n\t\t<div class=\"item-actions\">\n\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget edit-item\" title=\"Edit User\"></a>\n\t\t</div>\n\t\t<div class=\"user-name\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "userName"), env.opts.autoescape);
output += "</div>\n\t</div>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyToolbox/committeesToolbox.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"committees\" class=\"hierarchy-types\">\n\t<li class=\"curriculog-types-new-type\">\n\t\t<h1>New Committee</h1>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<label>Committee Name: </label>\n\t\t\t<input type=\"text\" name=\"committee-name\" id=\"committee-name\">\n\t\t</div>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<input type=\"hidden\" name=\"committee-id\" id=\"committee-id\">\n\t\t\t<input id=\"committee-create\" class=\"type-submit form-button\" type=\"button\" value=\"Create Committee\" disabled=\"disabled\">\n\t\t\t<input id=\"committee-update\" class=\"type-submit form-button\" type=\"button\" value=\"Update Committee\" disabled=\"disabled\" style=\"display:none\">\n\t\t\t<input id=\"committee-cancel\" class=\"type-reset form-button\" type=\"button\" value=\"Cancel\">\n\t\t</div>\n\t</li>\n\n\t<li class=\"curriculog-types-current-types-title\">\n\t\t<h1>Committees</h1>\n\t</li>\n\n\t";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "committees")) > 0) {
output += "\n\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "committees");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("committee", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t\t<li id=\"committee-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-types-current-type\">\n\t\t\t\t<div class=\"type-actions\">\n\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget\" title=\"Edit Committee\"></a>\n\t\t\t\t\t";
if(runtime.memberLookup((t_4),"canDelete", env.opts.autoescape)) {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget\" title=\"Remove Committee\"></a>\n\t\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget disabled\" title=\"Committee cannot be deleted\"></a>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t\t<span class=\"type-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "</span>\n\t\t\t</li>\n\t\t";
;
}
}
frame = frame.pop();
output += "\n\t";
;
}
else {
output += "\n\t\tThere are currently no committees. You may add a new committee above.\n\t";
;
}
output += "\n\n</ul>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyToolbox/entityTypesToolbox.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"entity-types\" class=\"hierarchy-types\">\n\t<li class=\"curriculog-types-new-type\">\n\t\t<h1>New Entity Type</h1>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<label for=\"entity-type-name\">Type Name: </label>\n\t\t\t<input type=\"text\" name=\"entity-type-name\" id=\"entity-type-name\">\n\t\t</div>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<input type=\"hidden\" name=\"entity-type-id\" id=\"entity-type-id\">\n\t\t\t<input id=\"entity-type-create\" class=\"type-submit form-button\" type=\"button\" value=\"Create Type\" disabled=\"disabled\">\n\t\t\t<input id=\"entity-type-update\" class=\"type-submit form-button\" type=\"button\" value=\"Update Type\" disabled=\"disabled\" style=\"display:none\">\n\t\t\t<input id=\"entity-type-cancel\" class=\"type-reset form-button\" type=\"button\" value=\"Cancel\">\n\t\t</div>\n\t</li>\n\n\t<li class=\"curriculog-types-current-types-title\">\n\t\t<h1>Entity Types</h1>\n\t</li>\n\n\t";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "entityTypes")) > 0) {
output += "\n\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "entityTypes");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("entityType", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t\t<li id=\"entity-type-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-types-current-type\">\n\t\t\t\t<div class=\"type-actions\">\n\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget\" title=\"Edit Type\"></a>\n\t\t\t\t\t";
if(runtime.memberLookup((t_4),"canDelete", env.opts.autoescape)) {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget\" title=\"Remove Type\"></a>\n\t\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget disabled\" title=\"Type cannot be deleted\"></a>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t\t<span class=\"type-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "</span>\n\t\t\t</li>\n\t\t";
;
}
}
frame = frame.pop();
output += "\n\t";
;
}
else {
output += "\n\t\tThere are currently no entity types. You may add a new entity type above.\n\t";
;
}
output += "\n</ul>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["HierarchyToolbox/roleTypesToolbox.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul id=\"role-types\" class=\"hierarchy-types\">\n\t<li class=\"curriculog-types-new-type\">\n\t\t<h1>New Role Type</h1>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<label>Type Name: </label>\n\t\t\t<input type=\"text\" name=\"role-type-name\" id=\"role-type-name\">\n\t\t</div>\n\t\t<div class=\"type-options clearfix\" style=\"height:5px;\"></div>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<label>Committee:</label>\n\t\t\t<input type=\"checkbox\" name=\"role-type-committee\" id=\"role-type-committee\">\n\t\t</div>\n\t\t<div class=\"type-options clearfix\">\n\t\t\t<input type=\"hidden\" name=\"role-type-id\" id=\"role-type-id\">\n\t\t\t<input type=\"hidden\" name=\"role-type-committee\" id=\"role-type-committee\">\n\n\t\t\t<input id=\"role-type-create\" class=\"type-submit form-button\" type=\"button\" value=\"Create Type\" disabled=\"disabled\">\n\t\t\t<input id=\"role-type-update\" class=\"type-submit form-button\" type=\"button\" value=\"Update Type\" disabled=\"disabled\" style='display:none'>\n\t\t\t<input id=\"role-type-cancel\" class=\"type-reset form-button\" type=\"button\" value=\"Cancel\">\n\t\t</div>\n\t</li>\n\n\t<li class=\"curriculog-types-current-types-title\">\n\t\t<h1>Role Types</h1>\n\t</li>\n\n\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "roleTypes");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("roleType", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t";
if(runtime.memberLookup((t_4),"id", env.opts.autoescape) == 1) {
output += "\n\t\t\t<li id=\"role-type-1\" class=\"curriculog-types-current-type system-role-type\">\n\t\t\t\t<span class=\"type-name system-role-type \">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "</span>\n\t\t\t</li>\n\t\t";
;
}
else {
output += "\n\t\t\t<li id=\"role-type-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-types-current-type \">\n\t\t\t\t<div class=\"type-actions\">\n\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget edit-widget\" title=\"Edit Type\"></a>\n\t\t\t\t\t";
if(runtime.memberLookup((t_4),"canDelete", env.opts.autoescape)) {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget\" title=\"Remove Type\"></a>\n\t\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t\t<a href=\"#\" class=\"curriculog-widget delete-widget disabled\" title=\"Type cannot be deleted\"></a>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t\t";
if(runtime.memberLookup((t_4),"committee", env.opts.autoescape)) {
output += "\n\t\t\t\t\t<span class=\"type-name committee-roleType\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "</span>\n\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t<span class=\"type-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "</span>\n\t\t\t\t";
;
}
output += "\n\t\t\t</li>\n\t\t";
;
}
output += "\n\t";
;
}
}
frame = frame.pop();
output += "\n\n</ul>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/StaticCurriculumCourseListItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"course\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"displayDescription", env.opts.autoescape), env.opts.autoescape);
output += "</li>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/addCoreCourseDialog.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<ul class=\"selectable-course-list\">\n\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "courses");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("course", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t<li class=\"select-field\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t\t<div class=\"course-name\">\n\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prefix", env.opts.autoescape), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"code", env.opts.autoescape), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t</div>\n\t\t<div class=\"course-credits\">\n\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"credits", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t</div>\n\t</li>\n\t";
;
}
}
frame = frame.pop();
output += "\n</ul>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/addCoreTextDialog.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div>\n\t<textarea class=\"input-custom-text\" placeholder=\"Custom Text\" /></textarea>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/core.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"core collapsed ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"locked", env.opts.autoescape)) {
output += "core-locked";
;
}
output += "\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t<fieldset>\n\t\t<div class=\"core-drag-handle\"></div>\n\n\t\t<div class=\"core-header\">\n\t\t\t<button type=\"button\" class=\"delete-core btn-delete tip\" title=\"Delete Core from Proposal\">\n\t\t\t\tRemove Schema\n\t\t\t</button>\n\t\t\t<h3 class=\"core-title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</h3>\n\t\t</div>\n\n\t\t<div class=\"core-content\">\n\t\t\t<div class=\"core-content-title\">\n\t\t\t\t<label class=\"core-title-field-label\" for=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-title\">Title</label>\n\t\t\t\t<input type=\"text\" name=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-title\" id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-title\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"core-field core-title-field\">\n\t\t\t\t<div class=\"core-title-buttons\">\n\t\t\t\t\t<button class=\"save-core-title btn\" type=\"button\">Save</button>\n\t\t\t\t\t<button class=\"cancel-core-edit btn\" type=\"button\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"core-content-description\">\n\t\t\t\t<label class=\"core-description-field-label\" for=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\">Description</label>\n\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "field")),"richText", env.opts.autoescape)) {
output += "\n\t\t\t\t\t<div contenteditable=\"true\" name=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\" id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\" class=\"core-field core-description-field ckeditor\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"description", env.opts.autoescape), env.opts.autoescape);
output += "</div>\n\t\t\t\t";
;
}
else {
output += "\n\t\t\t\t\t<textarea name=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\" id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\" class=\"core-field core-description-field\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"description", env.opts.autoescape), env.opts.autoescape);
output += "</textarea>\n\t\t\t\t";
;
}
output += "\n\t\t\t\t<div class=\"core-description-buttons\">\n\t\t\t\t\t<button class=\"save-core-description btn\" type=\"button\">Save</button>\n\t\t\t\t\t<button class=\"cancel-core-edit btn\" type=\"button\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"course-list-container\"></div>\n\t\t</div>\n\t</fieldset>\n\t<ol class=\"sub-cores\"></ol>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/coreCourseList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"course-list-container\">\n\t<label class=\"course-list-label\">Courses</label>\n\t<ol id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-courses\" class=\"action-list course-list sortable\">\n\n\t</ol>\n\t<button class=\"add-core-course btn\" type=\"button\">Add Courses</button>\n\t<button class=\"add-core-text btn\" type=\"button\">Add Custom Text</button>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/coreCustomText.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"custom-text ckeditor\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t<div class=\"drag-handle\"></div>\n\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"description", env.opts.autoescape), env.opts.autoescape);
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"Position", env.opts.autoescape)) {
output += "(position: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"Position", env.opts.autoescape), env.opts.autoescape);
output += ")";
;
}
output += "\n\t<div class=\"course-list-button-container\">\n\t\t<button type=\"button\" class=\"delete-course btn-delete\"></button>\n\t\t<button type=\"button\" class=\"edit-course btn-edit\"></button>\n\t</div>\n</li>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/courseListItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"course\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t<div class=\"drag-handle\"></div>\n\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"prefix", env.opts.autoescape), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"code", env.opts.autoescape), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t<div class=\"course-list-button-container\">\n\t\t<button type=\"button\" class=\"delete-course btn-delete\"></button>\n\t</div>\n</li>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/curriculum.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"field-placeholder curriculum\" style=\"width: 100%;\">\n\t<!-- Schema -->\n\t<div class=\"schema\">\n\t\t\n\t</div>\n\n\t<!-- Courses -->\n\t<div class=\"courses\">\n\n\t</div>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/curriculumCoreList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t\t<!-- Program Core List -->\n\t\t<div class=\"course-list-container\"></div>\n\n\t\t<!-- Core List -->\n\t\t<ol class=\"core-list\"></ol>\n\n\t\t<button type=\"button\" class=\"add-core btn\">Add Core</button>\n\t\t<button type=\"button\" class=\"import-core btn\">Import Core</button>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/curriculumCourseList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"course-list-container\">\n    <label class=\"course-list-label\">Courses</label>\n\n\t<ol class=\"action-list course-list sortable\"></ol>\n\n\t<button type=\"button\" class=\"add-course btn\">Add Course</button>\n\t<button type=\"button\" class=\"import-course btn\">Import Course</button>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/newCourseDialog.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"add-course-dialog\">\n\t<p>Add the course details below:</p>\n\t<ul>\n\t\t<li>\n\t\t\t<label for=\"prefix\">Prefix: </label>\n\t\t\t<input type=\"text\" name=\"prefix\" value=\"\" id=\"course-prefix\">\n\t\t</li>\n\t\t<li>\n\t\t\t<label for=\"code\">Code: </label>\n\t\t\t<input type=\"text\" name=\"code\" value=\"\" id=\"course-code\">\n\t\t</li>\n\t\t<li>\n\t\t\t<label for=\"name\">Name: </label>\n\t\t\t<input type=\"text\" name=\"name\" value=\"\" id=\"course-name\">\n\t\t</li>\n\t</ul>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/staticCoreCourseList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"course-list-container\">\n    <label class=\"course-list-label\">Courses</label>\n    <ol id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-courses\" class=\"action-list course-list\"></ol>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/staticCurriculumCore.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"core ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"locked", env.opts.autoescape)) {
output += "core-locked";
;
}
output += " collapsed\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t<fieldset>\n\t\t<!-- <div class=\"core-drag-handle\"></div> -->\n\n\t\t<div class=\"core-header\">\n\t\t\t<button type=\"button\" class=\"delete-core btn-delete tip\" title=\"Delete Core from Proposal\">\n\t\t\t\tRemove Schema\n\t\t\t</button>\n\t\t\t<button type=\"button\" class=\"icon-locked tip\" title=\"Shared Core and its subcores\"></button>\n\t\t\t<h3 class=\"core-title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</h3>\n\t\t</div>\n\n\t\t<div class=\"core-content\">\n\n\t\t\t<label class=\"core-title-field-label\" for=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-title\">Title</label>\n\t\t\t<div id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-title\" class=\"core-field core-title-field\">\n\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"displayName", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t\t</div>\n\n\t\t\t<label class=\"core-description-field-label\" for=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\">Description</label>\n\t\t\t<div id=\"core-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "-description\" class=\"core-field core-description-field\">\n\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"displayDescription", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t\t</div>\n\t\t\t";
env.getTemplate("ProposalForm/Form/Curriculum/staticCurriculumCourseList.html", false, "ProposalForm/Form/Curriculum/staticCurriculumCore.html", function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame.push(), function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\t\t</div>\n\t</fieldset>\n\t<ol class=\"sub-cores\">\n\t\t";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"cores", env.opts.autoescape);
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n\t\t\t";
env.getTemplate("ProposalForm/Form/Curriculum/staticCurriculumCore.html", false, "ProposalForm/Form/Curriculum/staticCurriculumCore.html", function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame.push(), function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\t\t";
})});
}
}
frame = frame.pop();
output += "\n\t</ol>\n</li>";
cb(null, output);
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/staticCurriculumCoreList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t\t<!-- Program Core List -->\n\t\t<div class=\"course-list-container\">\n\n\t\t</div>\n\n\t\t<!-- Core List -->\n\t\t<ol class=\"core-list\">\n\n\t\t</ol>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/staticCurriculumCourseList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"courses", env.opts.autoescape)) {
output += "\n<div class=\"course-activity-log\">\n\t<label class=\"course-activity-label\">Courses</label>\n</div>\n<div class=\"course-list-container\">\n\t<label class=\"course-list-label\">Courses</label>\n\t<ol class=\"action-list course-list sortable\">\n\t\t";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"courses", env.opts.autoescape);
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t\t";
if(runtime.memberLookup((t_4),"type", env.opts.autoescape) == "course") {
output += "\n\t\t\t\t";
env.getTemplate("ProposalForm/Form/Curriculum/StaticCurriculumCourseListItem.html", false, "ProposalForm/Form/Curriculum/staticCurriculumCourseList.html", function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame.push(), function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\t\t\t";
})});
}
else {
output += "\n\t\t\t\t";
env.getTemplate("ProposalForm/Form/Curriculum/staticCurriculumCustomTextItem.html", false, "ProposalForm/Form/Curriculum/staticCurriculumCourseList.html", function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame.push(), function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\t\t\t";
})});
}
output += "\n\t\t";
;
}
}
frame = frame.pop();
output += "\n\t</ol>\n</div>\n";
;
}
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/Curriculum/staticCurriculumCustomTextItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"custom-text\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t<div ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "field")),"richText", env.opts.autoescape)) {
output += "class=\"ckeditor\"";
;
}
output += ">\n\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"displayDescription", env.opts.autoescape), env.opts.autoescape);
output += "\n\t</div>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/LaunchDialog.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div>\n    <p>You are about to launch this proposal. Once you have launched this proposal, it will begin\n    the approval process. The proposal will appear in your task list under the \"My Proposals\" tab\n    and you may easily view its progress at any time. However, you may not edit the proposal after\n    launch unless you are included in a particular step of the approval process.</p>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/LaunchErrorDialog.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"launch-error-dialog\">\n    <p>Please correct the following errors before launching the proposal.</p>\n    <br />\n    <ul class=\"errors\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "messages");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("message", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n            <li class=\"error\">";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "</li>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/LaunchReviewDialog.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"launch-proposal-review-dialog\">\n    <p>You are about to launch this proposal for review. All crosslisted proposals must be reviewed by an Administrator before they can be launched.</p>\n\n    <p>Once your proposal is launched into review, an Administrator will review it.  Upon review, your proposal may be approved or rejected by the Administrator. If approved, your proposal will begin the approval process. The proposal will appear in your task list under the \"My Proposals\" tab and you may easily view its progress at any time. However, you may not edit the proposal after launch unless you are included in the particular step of the approval process.  If rejected, you will receive the proposal back in an unlaunched state where you may make changes and submit the proposal for review again.</p>\n</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/proposalEntityDropdownItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<option value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entity")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" data-depth=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entity")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalForm/Form/smartfieldDropdownItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div class=\"select2-indent\" data-depth=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "depth"), env.opts.autoescape);
output += "\" style=\"margin-left:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "padding"), env.opts.autoescape);
output += "px\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "text"), env.opts.autoescape);
output += "</div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/advancedFilterAdmin-cui.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<fieldset class=\"report-search-fields\">\n  <div class=\"form-group\">\n    <label for=\"report-9-keyword\">Keyword</label>\n    <input type=\"text\" name=\"report-9-keyword\" id=\"report-9-keyword\" value=\"\">\n  </div>\n  <div class=\"form-group-row found-under-date-range\">\n    <div class=\"form-group found-under\">\n      <label for=\"report-9-entity-types\" id=\"report-9-entity-types-label\">Found Under</label>\n      <select id=\"report-9-entity-types\" class=\"entity-types\" name=\"report-9-entity-types\">\n        <option value=\"\" data-depth=\"0\" data-children=\"false\">All Entities</option>\n      </select>\n      <div class=\"form-group checkbox\">\n        <input type=\"checkbox\" id=\"report-9-include-entity-children\" name=\"report-9-include-entity-children\" value=\"1\" disabled>\n        <label for=\"report-9-include-entity-children\" class=\"include-entity-children checkbox\">Include all child entities under my selection</label>\n      </div>\n    </div>\n    <div class=\"form-group-row date-range\">\n      <div class=\"form-group\">\n        <label for=\"report-9-date-type\" id=\"report-9-date-type-label\">Date Search Scope</label>\n        <select id=\"report-9-date-type\" name=\"report-9-date-type\">\n          <option value=\"\">Select a date type</option>\n          <option value=\"launchedDateRange\">Launched Between</option>\n          <option value=\"completedDateRange\" disabled=\"\">Completed Between (excludes already exported items)</option>\n          <option value=\"exportedDateRange\" disabled=\"\">Exported Between</option>\n        </select>\n      </div>\n      <div class=\"form-group-row date-fields\">\n        <div class=\"form-group\">\n          <label for=\"report-9-from\">From</label>\n          <input type=\"text\" name=\"report-9-from\" id=\"report-9-from\" value=\"\" readonly>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"report-9-to\" class=\"field-date-label-to\">To</label>\n          <input type=\"text\" name=\"report-9-to\" id=\"report-9-to\" value=\"\" readonly>\n        </div>\n        <div class=\"form-group\">\n          <button type=\"button\" name=\"clear-dates\" value=\"\" class=\"form-button filter-button\">\n            <span>Clear Dates</span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group-row process-type-step-name\">\n    <div class=\"form-group\">\n      <label for=\"report-9-process-id\" id=\"report-9-process-id-label\">Process Type</label>\n      <select id=\"report-9-process-id\" class=\"process-types\" name=\"report-9-process-id\">\n        <option value=\"\">All Processes</option>\n        <optgroup class=\"process-types\" label=\"All Processes of Type\">\n          <option value=\"course\">Course</option>\n          <option value=\"program\">Program</option>\n          <option value=\"other\">Other</option>\n        </optgroup>\n        <optgroup class=\"process-ids\" label=\"Individual Processes\"></optgroup>\n      </select>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"report-9-step-name\" id=\"report-9-step-name-label\">Current Step Name</label>\n      <select id=\"report-9-step-name\" class=\"step-names\" name=\"report-9-step-name\">\n        <option value=\"\">All Current Steps</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"form-group-row admin-checkboxes\">\n    <div class=\"form-group-row requests-sensitivity-participants\">\n      <fieldset class=\"form-group checkbox requests\">\n        <legend>Requests</legend>\n        <div class=\"form-group-row\">\n          <div>\n            <div class=\"option clearfix\">\n              <input type=\"checkbox\" name=\"report-9-decision-request-hold\" id=\"report-9-decision-request-hold\" class=\"decision\" value=\"1\" checked=\"checked\">\n              <label for=\"report-9-decision-request-hold\" class=\"checkbox\">Request Hold</label>\n            </div>\n            <div class=\"option clearfix\">\n              <input type=\"checkbox\" name=\"report-9-decision-request-suspend\" id=\"report-9-decision-request-suspend\" class=\"decision\" value=\"1\" checked=\"checked\">\n              <label for=\"report-9-decision-request-suspend\" class=\"checkbox\">Request Suspension</label>\n            </div>\n          </div>\n          <div>\n            <div class=\"option clearfix\">\n              <input type=\"checkbox\" name=\"report-9-decision-request-cancel\" id=\"report-9-decision-request-cancel\" class=\"decision\" value=\"1\" checked=\"checked\">\n              <label for=\"report-9-decision-request-cancel\" class=\"checkbox\">Request Cancellation</label>\n            </div>\n            <div class=\"option clearfix\">\n              <input type=\"checkbox\" name=\"report-9-decision-request-route\" id=\"report-9-decision-request-route\" class=\"decision\" value=\"1\" checked=\"checked\">\n              <label for=\"report-9-decision-request-route\" class=\"checkbox\">Request Custom Route</label>\n            </div>\n          </div>\n        </div>\n      </fieldset>\n\n      <div class=\"form-group-row\">\n        <fieldset class=\"form-group checkbox step-participants\">\n          <legend>Step Participants</legend>\n          <div class=\"field\">\n            <div class=\"half-field-options\">\n              <div class=\"option clearfix\">\n                <input type=\"checkbox\" name=\"report-9-empty\" id=\"report-9-empty\" value=\"empty\" disabled>\n                <label for=\"report-9-empty\" class=\"checkbox\">Current Step is Empty</label>\n              </div>\n            </div>\n          </div>\n        </fieldset>\n        <fieldset class=\"form-group checkbox time-sensitivity\">\n          <legend>Time Sensitivity</legend>\n          <div class=\"field\">\n            <div class=\"half-field-options\">\n              <div class=\"option clearfix\">\n                <input type=\"checkbox\" name=\"report-9-flag\" id=\"report-9-flag\" value=\"stuck\">\n                <label for=\"report-9-flag\" class=\"checkbox\">Stuck Proposals</label>\n              </div>\n            </div>\n          </div>\n        </fieldset>\n      </div>\n    </div>\n    <fieldset class=\"form-group checkbox proposal-status\">\n      <legend>Proposal Status</legend>\n      <div class=\"form-group-row\">\n        <div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-reviewing\" id=\"report-9-status-reviewing\" class=\"status\" value=\"1\">\n            <label for=\"report-9-status-reviewing\" class=\"checkbox\">Reviewing</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-active\" id=\"report-9-status-active\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-active\" class=\"checkbox\">Active</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-held\" id=\"report-9-status-held\" class=\"status\" value=\"1\">\n            <label for=\"report-9-status-held\" class=\"checkbox\">Held</label>\n          </div>\n        </div>\n        <div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-suspended\" id=\"report-9-status-suspended\" class=\"status\" value=\"1\">\n            <label for=\"report-9-status-suspended\" class=\"checkbox\">Suspended</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-cancelled\" id=\"report-9-status-cancelled\" class=\"status\" value=\"1\" disabled=\"disabled\">\n            <label for=\"report-9-status-cancelled\" class=\"checkbox\">Cancelled</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-waiting\" id=\"report-9-status-waiting\" class=\"status\" value=\"1\" disabled=\"disabled\">\n            <label for=\"report-9-status-waiting\" class=\"checkbox\">Waiting</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-completed\" id=\"report-9-status-completed\" class=\"status\" value=\"1\" disabled=\"disabled\">\n            <label for=\"report-9-status-completed\" class=\"checkbox\">Completed</label>\n          </div>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n</fieldset>\n<div class=\"fieldset-buttons clearfix\">\n  <button type=\"button\" name=\"generate-report\" value=\"\" class=\"form-button report-9\">\n    <span>Filter Proposals</span>\n  </button>\n  <button type=\"button\" name=\"cancel\" value=\"\" class=\"form-button report-9\">\n    <span>Cancel</span>\n  </button>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/advancedFilterAdmin.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-entity-types\" id=\"report-9-entity-types-label\">Found Under</label>\n\t\t\t\t\t<select id=\"report-9-entity-types\" class=\"entity-types\" name=\"report-9-entity-types\">\n\t\t\t\t\t\t<option data-children=\"false\" value=\"\" selected>All Entities</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-include-entity-children\"></label>\n\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t<input type=\"checkbox\" id=\"report-9-include-entity-children\" name=\"report-9-include-entity-children\" value=1>\n\t\t\t\t\t\t\t<label for=\"report-9-include-entity-children\" class=\"include-entity-children checkbox\">Include all child entities under my selection</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-process-id\" id=\"report-9-process-id-label\">Process Type</label>\n\t\t\t\t\t<select id=\"report-9-process-id\" class=\"process-types\" name=\"report-9-process-id\">\n\t\t\t\t\t\t<option value=\"\">All Processes</option>\n\t\t\t\t\t\t<optgroup label=\"All Processes of Type\">\n\t\t\t\t\t\t\t<option value=\"course\">Course</option>\n\t\t\t\t\t\t\t<option value=\"program\">Program</option>\n\t\t\t\t\t\t\t<option value=\"other\">Other</option>\n\t\t\t\t\t\t</optgroup>\n\t\t\t\t\t\t<optgroup label=\"Individual Process\">\n\t\t\t\t\t\t</optgroup>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-step-name\" id=\"report-9-step-name-label\">Current Step Name</label>\n\t\t\t\t\t<select id=\"report-9-step-name\" class=\"step-names\" name=\"report-9-step-name\">\n\t\t\t\t\t\t<option value=\"\">All Current Steps</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-date-type\" id=\"report-9-date-type-label\">Date Search Scope</label>\n\t\t\t\t\t<select id=\"report-9-date-type\" name=\"report-9-date-type\">\n\t\t\t\t\t\t<option value=\"\">Select a date type</option>\n\t\t\t\t\t\t<option value=\"launchedDateRange\">Launched Between</option>\n\t\t\t\t\t\t<option value=\"completedDateRange\">Completed Between (excludes already exported items)</option>\n\t\t\t\t\t\t<option value=\"exportedDateRange\">Exported Between</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"field-date\">\n\t\t\t\t\t<div class=\"legend label\">From</div>\n\t\t\t\t\t<input type=\"text\" name=\"report-9-from\" id=\"report-9-from\" value=\"\" readonly>\n\t\t\t\t\t<button type=\"button\" name=\"clear-dates\" value=\"\" class=\"form-button filter-button\">\n\t\t\t\t\t\t<span>Clear Dates</span>\n\t\t\t\t\t</button>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"field-date\">\n\t\t\t\t\t<label for=\"report-9-to\" class=\"field-date-label-to\">To</label>\n\t\t\t\t\t<input type=\"text\" name=\"report-9-to\" id=\"report-9-to\" value=\"\" readonly>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class=\"legend label\">Proposal Status</div>\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-reviewing\" id=\"report-9-status-reviewing\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-reviewing\" class=\"checkbox\">Reviewing</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-active\" id=\"report-9-status-active\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-active\" class=\"checkbox\">Active</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-held\" id=\"report-9-status-held\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-held\" class=\"checkbox\">Held</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-suspended\" id=\"report-9-status-suspended\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-suspended\" class=\"checkbox\">Suspended</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-cancelled\" id=\"report-9-status-cancelled\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-cancelled\" class=\"checkbox\">Cancelled</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-waiting\" id=\"report-9-status-waiting\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-waiting\" class=\"checkbox\">Waiting</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-completed\" id=\"report-9-status-completed\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-completed\" class=\"checkbox\">Completed</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class=\"legend label\">Requests</div>\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-decision-request-hold\" id=\"report-9-decision-request-hold\" class=\"decision\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-decision-request-hold\" class=\"checkbox\">Request Hold</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-decision-request-suspend\" id=\"report-9-decision-request-suspend\" class=\"decision\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-decision-request-suspend\" class=\"checkbox\">Request Suspension</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-decision-request-cancel\" id=\"report-9-decision-request-cancel\" class=\"decision\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-decision-request-cancel\" class=\"checkbox\">Request Cancellation</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-decision-request-route\" id=\"report-9-decision-request-route\" class=\"decision\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-decision-request-route\" class=\"checkbox\">Request Custom Route</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class=\"legend label\">Step Participants</div>\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-empty\" id=\"report-9-empty\" value=\"empty\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-empty\" class=\"checkbox\">Current Step is Empty</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class=\"legend label\">Time Sensitivity</div>\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-flag\" id=\"report-9-flag\" value=\"stuck\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-flag\" class=\"checkbox\">Stuck Proposals</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-keyword\">Keyword</label>\n\t\t\t\t\t<input type=\"text\" name=\"report-9-keyword\" id=\"report-9-keyword\" value=\"\">\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<div class=\"fieldset-buttons clearfix\">\n\t\t\t\t\t\t<button type=\"button\" name=\"generate-report\" value=\"\" class=\"form-button report-9\">\n\t\t\t\t\t\t\t<span>Filter Proposals</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button type=\"button\" name=\"cancel\" value=\"\" class=\"form-button report-9\">\n\t\t\t\t\t\t\t<span>Cancel</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/advancedFilterUser-cui.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<fieldset class=\"report-search-fields\">\n  <div class=\"form-group\">\n    <label for=\"report-9-keyword\">Keyword</label>\n    <input type=\"text\" name=\"report-9-keyword\" id=\"report-9-keyword\" value=\"\">\n  </div>\n  <div class=\"form-group-row found-under-date-range\">\n    <div class=\"form-group found-under\">\n      <label for=\"report-9-entity-types\" id=\"report-9-entity-types-label\">Found Under</label>\n      <select id=\"report-9-entity-types\" class=\"entity-types\" name=\"report-9-entity-types\">\n        <option data-children=\"false\" value=\"\" selected>All Entities</option>\n      </select>\n      <div class=\"form-group checkbox\">\n        <input type=\"checkbox\" id=\"report-9-include-entity-children\" name=\"report-9-include-entity-children\" value=\"1\" disabled>\n        <label for=\"report-9-include-entity-children\" class=\"include-entity-children checkbox\">Include all child entities under my selection</label>\n      </div>\n    </div>\n    <div class=\"form-group-row date-range\">\n      <div class=\"form-group\">\n        <label for=\"report-9-date-type\" id=\"report-9-date-type-label\">Date Search Scope</label>\n        <select id=\"report-9-date-type\" name=\"report-9-date-type\">\n          <option value=\"\">Select a date type</option>\n          <option value=\"launchedDateRange\">Launched Between</option>\n          <option value=\"completedDateRange\">Completed Between</option>\n        </select>\n      </div>\n      <div class=\"form-group-row date-fields\">\n        <div class=\"form-group\">\n          <label for=\"report-9-from\">From</label>\n          <input type=\"text\" name=\"report-9-from\" id=\"report-9-from\" value=\"\" readonly>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"report-9-to\" class=\"field-date-label-to\">To</label>\n          <input type=\"text\" name=\"report-9-to\" id=\"report-9-to\" value=\"\" readonly>\n        </div>\n        <div class=\"form-group\">\n          <button type=\"button\" name=\"clear-dates\" value=\"\" class=\"form-button filter-button\">\n          <span>Clear Dates</span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group-row process-type-step-name\">\n    <div class=\"form-group\">\n      <label for=\"report-9-process-id\" id=\"report-9-process-id-label\">Process Type</label>\n      <select id=\"report-9-process-id\" class=\"process-types\" name=\"report-9-process-id\">\n        <option value=\"\">All Processes</option>\n        <optgroup class=\"process-types\" label=\"All Processes of Type\">\n          <option value=\"course\">Course</option>\n          <option value=\"program\">Program</option>\n          <option value=\"other\">Other</option>\n        </optgroup>\n        <optgroup class=\"process-ids\" label=\"Individual Processes\"></optgroup>\n      </select>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"report-9-step-name\" id=\"report-9-step-name-label\">Current Step Name</label>\n      <select id=\"report-9-step-name\" class=\"step-names\" name=\"report-9-step-name\">\n        <option value=\"\">All Current Steps</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"form-group-row role-time-status\">\n    <div class=\"role-time-sensitivity\">\n      <div class=\"form-group\">\n        <label for=\"report-9-role-id\" id=\"report-9-role-id-label\">My Role</label>\n        <!-- NOTE: option change from \"No User Roles Available\" to \"No Roles Available\" -->\n        <select id=\"report-9-role-id\" class=\"user-roles\" name=\"report-9-role-id\" disabled>\n          <option value=\"course\">All My Roles</option>\n        </select>\n      </div>\n      <fieldset class=\"form-group checkbox time-sensitivity\">\n        <legend>Time Sensitivity</legend>\n        <div class=\"form-group-row\">\n          <label for=\"report-9-flag\" class=\"checkbox\">\n          <input type=\"checkbox\" name=\"report-9-flag\" id=\"report-9-flag\" value=\"urgent\">\n          My Urgent Tasks\n          </label>\n          <label for=\"report-9-deadline\" class=\"checkbox\">\n          <input type=\"checkbox\" name=\"report-9-deadline\" id=\"report-9-deadline\" value=\"deadline\">\n          My Tasks with Deadlines\n          </label>\n        </div>\n      </fieldset>\n    </div>\n    <fieldset class=\"form-group checkbox proposal-status\">\n      <!-- NOTE: element change from div to legend -->\n      <legend>Proposal Status</legend>\n      <div class=\"form-group-row\">\n        <div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-unlaunched\" id=\"report-9-status-unlaunched\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-unlaunched\" class=\"checkbox\">Unlaunched (you are originator)</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-reviewing\" id=\"report-9-status-reviewing\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-reviewing\" class=\"checkbox\">Reviewing (you are originator)</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-active\" id=\"report-9-status-active\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-active\" class=\"checkbox\">Active</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-held\" id=\"report-9-status-held\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-held\" class=\"checkbox\">Held</label>\n          </div>\n        </div>\n        <div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-suspended\" id=\"report-9-status-suspended\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-suspended\" class=\"checkbox\">Suspended</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-cancelled\" id=\"report-9-status-cancelled\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-cancelled\" class=\"checkbox\">Cancelled</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-waiting\" id=\"report-9-status-waiting\" class=\"status\" value=\"1\" checked=\"checked\">\n            <label for=\"report-9-status-waiting\" class=\"checkbox\">Waiting</label>\n          </div>\n          <div class=\"option clearfix\">\n            <input type=\"checkbox\" name=\"report-9-status-completed\" id=\"report-9-status-completed\" class=\"status\" value=\"1\">\n            <label for=\"report-9-status-completed\" class=\"checkbox\">Completed</label>\n          </div>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n  <div class=\"form-group-row fieldset-buttons\">\n    <div class=\"form-group\">\n      <button type=\"button\" name=\"generate-report\" value=\"\" class=\"form-button\">\n        <span>Filter Proposals</span>\n      </button>\n    </div>\n    <div class=\"form-group\">\n      <button type=\"button\" name=\"cancel\" value=\"\" class=\"form-button\">\n        <span>Cancel</span>\n      </button>\n    </div>\n  </div>\n</fieldset>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/advancedFilterUser.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-entity-types\" id=\"report-9-entity-types-label\">Found Under</label>\n\t\t\t\t\t<select id=\"report-9-entity-types\" class=\"entity-types\" name=\"report-9-entity-types\">\n\t\t\t\t\t\t<option data-children=\"false\" value=\"\" selected>All Entities</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-include-entity-children\"></label>\n\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t<input type=\"checkbox\" id=\"report-9-include-entity-children\" name=\"report-9-include-entity-children\" value=1>\n\t\t\t\t\t\t\t<label for=\"report-9-include-entity-children\" class=\"include-entity-children checkbox\">Include all child entities under my selection</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-process-id\" id=\"report-9-process-id-label\">Process Type</label>\n\t\t\t\t\t<select id=\"report-9-process-id\" class=\"process-types\" name=\"report-9-process-id\">\n\t\t\t\t\t\t<option value=\"\">All Processes</option>\n\t\t\t\t\t\t<optgroup label=\"All Processes of Type\">\n\t\t\t\t\t\t\t<option value=\"course\">Course</option>\n\t\t\t\t\t\t\t<option value=\"program\">Program</option>\n\t\t\t\t\t\t\t<option value=\"other\">Other</option>\n\t\t\t\t\t\t</optgroup>\n\t\t\t\t\t\t<optgroup label=\"Individual Process\">\n\t\t\t\t\t\t</optgroup>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-role-id\">User Role</label>\n\t\t\t\t\t<select id=\"report-9-role-id\" class=\"user-roles\" name=\"report-9-role-id\">\n\t\t\t\t\t\t<option value=\"course\">All My Roles</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-step-name\" id=\"report-9-step-name-label\">Current Step Name</label>\n\t\t\t\t\t<select id=\"report-9-step-name\" class=\"step-names\" name=\"report-9-step-name\">\n\t\t\t\t\t\t<option value=\"\">All Current Steps</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-date-type\" id=\"report-9-date-type-label\">Date Search Scope</label>\n\t\t\t\t\t<select id=\"report-9-date-type\" name=\"report-9-date-type\">\n\t\t\t\t\t\t<option value=\"\">Select a date type</option>\n\t\t\t\t\t\t<option value=\"launchedDateRange\">Launched Between</option>\n\t\t\t\t\t\t<option value=\"completedDateRange\">Completed Between</option>\n\t\t\t\t\t</select>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"field-date\">\n\t\t\t\t\t<div class=\"legend label\">From</div>\n\t\t\t\t\t<input type=\"text\" name=\"report-9-from\" id=\"report-9-from\" value=\"\" readonly>\n\t\t\t\t\t<button type=\"button\" name=\"clear-dates\" value=\"\" class=\"form-button filter-button\">\n\t\t\t\t\t\t<span>Clear Dates</span>\n\t\t\t\t\t</button>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"field-date\">\n\t\t\t\t\t<label for=\"report-9-to\" class=\"field-date-label-to\">To</label>\n\t\t\t\t\t<input type=\"text\" name=\"report-9-to\" id=\"report-9-to\" value=\"\" readonly>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class=\"legend label\">Proposal Status</div>\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-unlaunched\" id=\"report-9-status-unlaunched\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-unlaunched\" class=\"checkbox\">Unlaunched (you are originator)</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-reviewing\" id=\"report-9-status-reviewing\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-reviewing\" class=\"checkbox\">Reviewing (you are originator)</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-active\" id=\"report-9-status-active\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-active\" class=\"checkbox\">Active</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-held\" id=\"report-9-status-held\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-held\" class=\"checkbox\">Held</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-suspended\" id=\"report-9-status-suspended\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-suspended\" class=\"checkbox\">Suspended</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-cancelled\" id=\"report-9-status-cancelled\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-cancelled\" class=\"checkbox\">Cancelled</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-waiting\" id=\"report-9-status-waiting\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-waiting\" class=\"checkbox\">Waiting</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-status-completed\" id=\"report-9-status-completed\" class=\"status\" value=\"1\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-status-completed\" class=\"checkbox\">Completed</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<fieldset>\n\t\t\t\t\t\t<div class=\"legend label\">Time Sensitivity</div>\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-flag\" id=\"report-9-flag\" value=\"urgent\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-flag\" class=\"checkbox\">My Urgent Tasks</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"half-field-options\">\n\t\t\t\t\t\t\t\t<div class=\"option clearfix\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"report-9-deadline\" id=\"report-9-deadline\" value=\"deadline\">\n\t\t\t\t\t\t\t\t\t<label for=\"report-9-deadline\" class=\"checkbox\">My Tasks with Deadlines</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</fieldset>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<label for=\"report-9-keyword\">Keyword</label>\n\t\t\t\t\t<input type=\"text\" name=\"report-9-keyword\" id=\"report-9-keyword\" value=\"\">\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<div class=\"fieldset-buttons clearfix\">\n\t\t\t\t\t\t<button type=\"button\" name=\"generate-report\" value=\"\" class=\"form-button report-9\">\n\t\t\t\t\t\t\t<span>Filter Proposals</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button type=\"button\" name=\"cancel\" value=\"\" class=\"form-button report-9\">\n\t\t\t\t\t\t\t<span>Cancel</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalList.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"curriculog-list-column\">\n\n\t<div id=\"curriculog-list-column-tabs\" class=\"clearfix\"></div>\n\n\t<div id=\"curriculog-list-column-results\">\n\n\t\t<div id=\"curriculog-list-column-results-actions\">\n      ";
if(!runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  \t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) > 0 && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"permissions", env.opts.autoescape)),"permissions_originate_proposals", env.opts.autoescape) == 1) || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) == 1)) {
output += "\n  \t\t\t<a href=\"/approval-processes\" class=\"curriculog-widget add-widget tip\" title=\"Start Proposal\">\n  \t\t\t\t<strong>New Proposal</strong>\n  \t\t\t</a>\n  \t\t\t";
;
}
output += "\n      ";
;
}
output += "\n\t\t\t";
if(!runtime.contextOrFrameLookup(context, frame, "cui_enabled") && runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) > 0) {
output += "\n\t\t\t<a href=\"#\" class=\"curriculog-widget approve-selected-widget tip\" title=\"Approval Multiple Proposals\">\n\t\t\t\t<span class=\"screen-reader-text\">Approve Selected Proposals</span>\n\t\t\t\t<strong aria-label=\"\">Approve Selected</strong>\n\t\t\t</a>\n\t\t\t";
;
}
output += "\n\t\t</div>\n\n\t\t<div id=\"curriculog-list-column-results-sorting\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      ";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) > 0 && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"permissions", env.opts.autoescape)),"permissions_originate_proposals", env.opts.autoescape) == 1) || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) == 1)) {
output += "\n      <a href=\"/approval-processes\" class=\"curriculog-widget add-widget tip\" title=\"Start Proposal\">\n        <strong>New Proposal</strong>\n      </a>\n      ";
;
}
output += "\n    ";
;
}
output += "\n    </div>\n\n\t\t<ul id=\"curriculog-list-column-results-content\"></ul>\n    ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n    <div id=\"curriculog-list-column-results-actions-bottom\">\n      ";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) > 0) {
output += "\n\t\t\t<a href=\"#\" class=\"curriculog-widget approve-selected-widget tip\" title=\"Approval Multiple Proposals\">\n\t\t\t\t<span class=\"screen-reader-text\">Approve Selected Proposals</span>\n\t\t\t\t<strong aria-label=\"\">Approve Selected</strong>\n\t\t\t</a>\n\t\t\t";
;
}
output += "\n    </div>\n    ";
;
}
output += "\n\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled") && runtime.contextOrFrameLookup(context, frame, "hasAccess")) {
output += "\n    <div id=\"curriculog-list-column-results-pagination\">\n      <div id=\"curriculog-list-column-results-paging\"></div>\n      <div id=\"curriculog-list-column-results-sorting-count\">\n        <label for=\"limit\" id=\"limit-label\">Show:</label>\n        <select name=\"limit\" id=\"limit\">\n          <option value=\"10\">10 results</option>\n          <option value=\"25\">25 results</option>\n          <option value=\"50\">50 results</option>\n        </select>\n      </div>\n    </div>\n    ";
;
}
else {
output += "\n    <div id=\"curriculog-list-column-results-paging\"></div>\n    ";
;
}
output += "\n\t</div>\n\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListFilters-CUI.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<input type=\"hidden\" name=\"level\" id=\"level\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "params")),"level", env.opts.autoescape), env.opts.autoescape);
output += "\">\n<div>\n\t<label for=\"filterBy\" id=\"filterBy-label\">Filter by:</label>\n\t<select name=\"filterBy\" id=\"filterBy\"></select>\n</div>\n<div id=\"advanced-filter\">\n\t<a href=\"#\" class=\"advanced-search\">Advanced Filter</a>\n\t<div id=\"curriculog-list-column-results-sorting-advanced\">\n\t\t<div class=\"report-filter\">\n\t\t\t<fieldset>\n\t\t\t\t<ul class=\"report-search-fields\"></ul>\n\t\t\t</fieldset>\n\t\t</div>\n\t</div>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListFilters.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<input type=\"hidden\" name=\"level\" id=\"level\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "params")),"level", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t<label for=\"filterBy\" id=\"filterBy-label\">Filter by:</label>\n\t<select name=\"filterBy\" id=\"filterBy\"></select>\n<div id=\"advanced-filter\">\n\t<a href=\"#\" class=\"advanced-search\">Advanced Filter</a>\n\t<div id=\"curriculog-list-column-results-sorting-advanced\">\n\t\t<div class=\"report-filter\">\n\t\t\t<fieldset>\n\t\t\t\t<ul class=\"report-search-fields\"></ul>\n\t\t\t</fieldset>\n\t\t</div>\n\t</div>\n</div>\n<div id=\"curriculog-list-column-results-sorting-count\">\n\t<label for=\"limit\" id=\"limit-label\">Show:</label>\n\t<select name=\"limit\" id=\"limit\">\n\t\t<option value=\"10\">10 results</option>\n\t\t<option value=\"25\">25 results</option>\n\t\t<option value=\"50\">50 results</option>\n\t</select>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListFlyout.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"summary-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"summary\">\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n\t<div class=\"summary-toolbar\">\n\t\t<h2 class=\"summary-heading\">Process Summary</h2>\n\t\t<a href=\"#\" class=\"curriculog-widget close-widget close-summary\"><strong>Close</strong></a>\n\t</div>\n  ";
;
}
output += "\n\t<div class=\"summary-content summary-content-title\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n    <h2 class=\"summary-title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</h2>\n    <button class=\"curriculog-widget close-widget close-summary\"><strong class=\"screen-reader-text\">Close</strong></button>\n    ";
;
}
else {
output += "\n\t\t<h3 class=\"summary-title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "</h3>\n    ";
;
}
output += "\n\t</div>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li\n\tclass=\"status-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += " open-summary\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"isTask", env.opts.autoescape)) {
output += "task\n\t\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"isMine", env.opts.autoescape)) {
output += "mine\n\t\t";
;
}
;
}
output += "\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "\n\t\tcurrent-step-id-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"currentStepID", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t";
;
}
output += "\"\n\tid=\"detail-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\"\n  tabindex=\"0\"\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "role=\"link\" ";
;
}
output += "\n  data-proposal-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.contextOrFrameLookup(context, frame, "isTaskTab")) {
output += "\n\t<div class=\"multi-approve-checkbox\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "canApprove")) {
output += "\n      ";
if(runtime.contextOrFrameLookup(context, frame, "needsPaperSignature")) {
output += "\n      <input type=\"checkbox\" id=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" name=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"approve-check\" data-proposalId=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" data-proposalName=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\" data-signatureRequired=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "needsSignature"), env.opts.autoescape);
output += "\" disabled title=\"Paper Signature required\">\n       ";
;
}
else {
output += "\n      <input type=\"checkbox\" id=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" name=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"approve-check\" data-proposalId=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" data-proposalName=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\" data-signatureRequired=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "needsSignature"), env.opts.autoescape);
output += "\" data-currentStepID=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"currentStepID", env.opts.autoescape), env.opts.autoescape);
output += "\">\n      ";
;
}
output += "\n    ";
;
}
else {
output += "\n      <input type=\"checkbox\" id=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" name=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"approve-check\" data-proposalId=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" data-proposalName=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\" disabled title=\"Proposal is ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += "\">\n    ";
;
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "canApprove")) {
output += "\n      <label for=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"screen-reader-text approve-check-label\">Select ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += " for Approval</label>\n    ";
;
}
else {
output += "\n      <label for=\"approve-check-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"screen-reader-text approve-check-label tip\" title=\"Proposal is ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += "\">Select ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += " for Approval</label>\n    ";
;
}
output += "\n\n </div>\n\t";
;
}
output += "\n\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.contextOrFrameLookup(context, frame, "isTaskTab")) {
output += "\n\t\t<div class=\"summary-item\">\n\t";
;
}
output += "\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  <div class=\"list-item-info\">\n    <h2 class=\"list-name\"\n    data-is-crosslisted=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape), env.opts.autoescape);
output += " tabindex=\"0\">\n        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"isUrgent", env.opts.autoescape) && runtime.contextOrFrameLookup(context, frame, "level") != "admin") {
output += "<div class=\"list-name-img urgent\"><span class=\"screen-reader-text\">Proposal is urgent.</span></div>";
;
}
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"flag", env.opts.autoescape) == "stuck" && runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "<div class=\"list-name-img stuck\"><span class=\"screen-reader-text\">Proposal is stuck.</span></div>";
;
}
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape)) {
output += "<div class=\"list-name-img crosslisted tip\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslistedFamily", env.opts.autoescape), env.opts.autoescape);
output += "\"><span class=\"screen-reader-text\">Proposal is crosslisted.</span></div>";
;
}
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape) == "completed") {
output += "<div class=\"list-name-img completed\"><span class=\"screen-reader-text\">Proposal is completed.</span></div>";
;
}
output += "\n    </h2>\n    <dl class=\"list-details clearfix\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape) == "unlaunched") {
output += "\n      <dt>Status:</dt>\n      <dd>Unlaunched</dd>\n    ";
;
}
else {
output += "\n      <dd>\n        <ul class=\"step-statuses-icons clearfix\">\n        ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"steps", env.opts.autoescape);
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("step", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n          ";
if(runtime.memberLookup((t_4),"name", env.opts.autoescape) != "Unlaunched Step") {
output += "\n          <li class=\"step-status-icon id-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id", env.opts.autoescape), env.opts.autoescape);
output += " step-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"image", env.opts.autoescape), env.opts.autoescape);
output += " tip\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name", env.opts.autoescape), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"statusText", env.opts.autoescape), env.opts.autoescape);
output += "\" tabindex=\"0\"></li>\n          ";
;
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n        </ul>\n      </dd>\n    ";
;
}
output += "\n      <dd class=\"list-ap\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"approvalProcessName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n      <dt tabindex=\"0\">Last Activity:</dt>\n      <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"date", env.opts.autoescape), env.opts.autoescape);
output += " by ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"user", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n    </dl>\n  </div>\n  <ul class=\"actions\">\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canExport", env.opts.autoescape) && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"exportDate", env.opts.autoescape)) {
output += "\n    <li>\n      <button class=\"action-export tip unchecked\" title=\"Ready for Export\">\n        <span class=\"screen-reader-text\">Not Ready for Export</span>\n      </button>\n    </li>\n\n    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canExport", env.opts.autoescape) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"exportDate", env.opts.autoescape)) {
output += "\n    <li>\n      <button class=\"action-export tip checked\" title=\"Undo Ready for Export\">\n        <span class=\"screen-reader-text\">Ready for Export</span>\n      </button>\n    </li>\n    ";
;
}
;
}
output += "\n\n  ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canDelete", env.opts.autoescape)) {
output += "\n  <li>\n    <button class=\"action-delete tip\" title=\"Delete Proposal\">\n      <span class=\"screen-reader-text\">Delete Proposal</span>\n    </button>\n  </li>\n  ";
;
}
output += "\n\n  ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canMessage", env.opts.autoescape)) {
output += "\n  <li>\n    <button class=\"action-message tip\" title=\"Send Message about Proposal\">\n      <span class=\"screen-reader-text\">Send Message about Proposal</span>\n    </button>\n  </li>\n  ";
;
}
output += "\n\n  ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canWatch", env.opts.autoescape) && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"isWatching", env.opts.autoescape)) {
output += "\n  <li>\n    <button class=\"action-unwatch tip\" title=\"Done Watching Proposal\">\n      <span class=\"screen-reader-text\">Done Watching Proposal</span>\n    </button>\n  </li>\n  ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canWatch", env.opts.autoescape) && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"isWatching", env.opts.autoescape)) {
output += "\n  <li>\n    <button class=\"action-watch tip\" title=\"Watch Proposal\">\n    <span class=\"screen-reader-text\">Watch Proposal</span>\n    </button>\n  </li>\n  ";
;
}
;
}
output += "\n  ";
if(runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "\n    <li>\n      <button class=\"action-view tip\" title=\"View Proposal\">\n        <span class=\"screen-reader-text\">View Proposal</span>\n      </button>\n    </li>\n  ";
;
}
output += "\n    <li>\n      <button class=\"action-summary tip\" title=\"View Summary\">\n        <span class=\"screen-reader-text\">View Summary</span>\n      </button>\n    </li>\n\n  </ul>\n  ";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"showDecision", env.opts.autoescape) && !runtime.contextOrFrameLookup(context, frame, "isUnlaunched")) {
output += "\n  <div\n  class=\"my-current-decision decision-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"currentDecision", env.opts.autoescape)),"decision", env.opts.autoescape), env.opts.autoescape);
output += " tip\"\n  title=\"My current decision: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"currentDecision", env.opts.autoescape)),"decisionText", env.opts.autoescape), env.opts.autoescape);
output += "\">\n  </div>\n  ";
;
}
output += "\n\n  ";
;
}
else {
output += "\n\t\t <h3 class=\"list-name\"\n\t\t data-is-crosslisted=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape), env.opts.autoescape);
output += " tabindex=\"0\">\n     ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t\t ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"isUrgent", env.opts.autoescape) && runtime.contextOrFrameLookup(context, frame, "level") != "admin") {
output += "<div class=\"list-name-img urgent\"><span class=\"screen-reader-text\">Urgent</span></div>";
;
}
output += "\n\t\t ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"flag", env.opts.autoescape) == "stuck" && runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "<div class=\"list-name-img stuck\"><span class=\"screen-reader-text\">Stuck</span></div>";
;
}
output += "\n\t\t ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape)) {
output += "<div class=\"list-name-img crosslisted tip\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslistedFamily", env.opts.autoescape), env.opts.autoescape);
output += "\"></div>";
;
}
output += "\n\t\t ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape) == "completed") {
output += "<div class=\"list-name-img completed\"><span class=\"screen-reader-text\">Completed</span></div>";
;
}
output += "</h3>\n\t<ul class=\"actions\">\n\t\t<li>\n\t\t\t<button class=\"action-summary tip\" title=\"View Summary\">\n\t\t\t\t<span class=\"screen-reader-text\">View Summary</span>\n\t\t\t</button>\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canEdit", env.opts.autoescape)) {
output += "\n\t\t\t<button class=\"action-edit tip\" title=\"Edit Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Edit Proposal</span>\n\t\t\t</button>\n\t\t\t";
;
}
else {
output += "\n\t\t\t<button class=\"action-view tip\" title=\"View Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">View Proposal</span>\n\t\t\t</button>\n\t\t\t";
;
}
output += "\n\n      ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canDelete", env.opts.autoescape)) {
output += "\n\t\t\t<button class=\"action-delete tip\" title=\"Delete Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Delete Proposal</span>\n\t\t\t</button>\n\t\t\t";
;
}
output += "\n\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canMessage", env.opts.autoescape)) {
output += "\n\t\t\t<button class=\"action-message tip\" title=\"Send Message about Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Send Message about Proposal</span>\n\t\t\t</button>\n\t\t\t";
;
}
output += "\n\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canExport", env.opts.autoescape) && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"exportDate", env.opts.autoescape)) {
output += "\n\t\t\t<button class=\"action-export tip\" title=\"Mark Ready for Export\">\n\t\t\t\t<span class=\"screen-reader-text\">Mark Ready for Export</span>\n\t\t\t</button>\n\n\t\t\t";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canExport", env.opts.autoescape) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"exportDate", env.opts.autoescape)) {
output += "\n      <button class=\"action-export tip undo\" title=\"Undo Ready for Export\" style=\"opacity: 0.3;\">\n      \t<span class=\"screen-reader-text\">Undo Ready for Export</span>\n\t\t\t</button>\n\t\t\t";
;
}
;
}
output += "\n\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canWatch", env.opts.autoescape) && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"isWatching", env.opts.autoescape)) {
output += "\n\t\t\t<button class=\"action-unwatch tip\" title=\"Done Watching Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Done Watching Proposal</span>\n\t\t\t</button>\n\t\t\t";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"canWatch", env.opts.autoescape) && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"isWatching", env.opts.autoescape)) {
output += "\n\t\t\t<button class=\"action-watch tip\" title=\"Watch Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Watch Proposal</span>\n\t\t\t</button>\n\t\t\t";
;
}
;
}
output += "\n\t\t</li>\n\t</ul>\n\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"proposalPermissions", env.opts.autoescape)),"showDecision", env.opts.autoescape) && !runtime.contextOrFrameLookup(context, frame, "isUnlaunched")) {
output += "\n\t<div\n\t\tclass=\"my-current-decision decision-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"currentDecision", env.opts.autoescape)),"decision", env.opts.autoescape), env.opts.autoescape);
output += " tip\"\n\t\ttitle=\"My current decision: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"currentDecision", env.opts.autoescape)),"decisionText", env.opts.autoescape), env.opts.autoescape);
output += "\">\n\t</div>\n\t";
;
}
output += "\n\n\t<dl class=\"list-details clearfix\">\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape) == "unlaunched") {
output += "\n\n\t\t<dt>Status:</dt>\n\t\t<dd>Unlaunched</dd>\n\n\t";
;
}
else {
output += "\n    <dt class=\"step-label\" tabindex=\"0\">Steps:</dt>\n\t\t<dd>\n\t\t\t<ul class=\"step-statuses-icons clearfix\">\n\t\t\t\t";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"steps", env.opts.autoescape);
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("step", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n          ";
if(runtime.memberLookup((t_8),"name", env.opts.autoescape) != "Unlaunched Step") {
output += "\n  \t\t\t\t<li class=\"step-status-icon id-";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id", env.opts.autoescape), env.opts.autoescape);
output += " step-";
output += runtime.suppressValue(runtime.memberLookup((t_8),"image", env.opts.autoescape), env.opts.autoescape);
output += " tip\"\n  \t\t\t\t\ttitle=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name", env.opts.autoescape), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"statusText", env.opts.autoescape), env.opts.autoescape);
output += "\" tabindex=\"0\">\n  \t\t\t\t</li>\n          ";
;
}
output += "\n\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t</ul>\n\t\t</dd>\n\t\t<dt tabindex=\"0\">Last Activity:</dt>\n\t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"date", env.opts.autoescape), env.opts.autoescape);
output += " by ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"user", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\t</dl>\n  ";
;
}
output += "\n  ";
;
}
output += "\n\t";
if(runtime.contextOrFrameLookup(context, frame, "level") == "user" && runtime.contextOrFrameLookup(context, frame, "isTaskTab")) {
output += "\n\t</div>\n\t";
;
}
output += "\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListLoading.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"no-summary\" id=\"detail-0\">\n\t<h3 class=\"list-name loading\" tabindex=\"0\">Retrieving Proposals</h3>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListNoAccess.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"error-page clearfix\">\n\t<span id=\"blue-page-message\" tabindex=\"0\">You must be logged in to view proposals.</span>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListNone.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"no-summary\" id=\"detail-0\">\n\t<h3 class=\"list-name no-results\" tabindex=\"0\">No Proposals Found</h3>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListPaging.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\nPage:\n\n";
if(runtime.contextOrFrameLookup(context, frame, "page") == 1) {
output += "\n<div class=\"paging-disabled\">1</div>\n";
;
}
else {
output += "\n<a href=\"#\" class=\"paging-1\">1</a>\n";
;
}
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"pageRangePrevious", env.opts.autoescape) > 0) {
output += "\n<span> &laquo; </span>\n<a href=\"#\" class=\"paging-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"pageRangePrevious", env.opts.autoescape), env.opts.autoescape);
output += "\">Back 10</a>\n<span> ... </span>\n";
;
}
output += "\n\n";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"currentRange", env.opts.autoescape);
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("i", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t";
if(runtime.contextOrFrameLookup(context, frame, "page") == t_4) {
output += "\n<div class=\"paging-disabled\">";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "</div>\n\t";
;
}
else {
output += "\n<a href=\"#\" class=\"paging-";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "</a>\n\t";
;
}
;
}
}
frame = frame.pop();
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"pageRangeNext", env.opts.autoescape) > 0) {
output += "\n<span> ... </span>\n<a href=\"#\" class=\"paging-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"pageRangeNext", env.opts.autoescape), env.opts.autoescape);
output += "\">Forward 10</a>\n<span> &raquo; </span>\n";
;
}
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape) > 10 && runtime.contextOrFrameLookup(context, frame, "page") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape)) {
output += "\n<div class=\"paging-disabled\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape), env.opts.autoescape);
output += "</div>\n";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape) > 10 && runtime.contextOrFrameLookup(context, frame, "page") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape)) {
output += "\n<a href=\"#\" class=\"paging-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "paging")),"totalPages", env.opts.autoescape), env.opts.autoescape);
output += "</a>\n";
;
}
;
}
output += "\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/proposalListTabs.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<ul>\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) == 0) {
output += "\n\t\t<li class=\"all-proposals-tab active\">\n\t\t\t<a href=\"/\">\n\t\t\t\tProposals\n\t\t\t</a>\n\t\t</li>\n\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "\n\t\t<li class=\"needsattention-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "needsattention") {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"> Needs Attention</a>\n\t\t</li>\n\t\t<li class=\"completed-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "completed") {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"> Approved</a>\n\t\t</li>\n\t\t<li class=\"manage-proposals-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "manage-proposals") {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"> All Proposals</a>\n\t\t</li>\n\t";
;
}
else {
output += "\n\t\t<li class=\"task-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "task" || !runtime.contextOrFrameLookup(context, frame, "tab")) {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"><img src=\"/images/dashboard_task.png\" alt=\"\"> My Tasks</a>\n\t\t</li>\n\t\t<li class=\"mine-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "mine") {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"><img src=\"/images/dashboard_mine.png\" alt=\"\"> My Proposals</a>\n\t\t</li>\n\t\t<li class=\"watching-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "watching") {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"> Watch List</a>\n\t\t</li>\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "showAllProposals") == true) {
output += "\n\t\t<li class=\"all-proposals-tab ";
if(runtime.contextOrFrameLookup(context, frame, "tab") == "all-proposals") {
output += "active";
;
}
output += "\">\n\t\t\t<a href=\"#\"> All Proposals</a>\n\t\t</li>\n\t\t";
;
}
output += "\n\t";
;
}
;
}
output += "\n\n\t</ul>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterAllProposals.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All Proposals</option>\n\t<optgroup label=\"Proposal Status\">\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) > 0) {
output += "\n\t\t<option value=\"proposal_status_unlaunched\">Unlaunched</option>\n\t\t<option value=\"proposal_status_reviewing\">Reviewing</option>\n\t\t";
;
}
output += "\n\t\t<option value=\"proposal_status_active\">Active</option>\n\t\t<option value=\"proposal_status_held\">Held</option>\n\t\t<option value=\"proposal_status_suspended\">Suspended</option>\n\t\t<option value=\"proposal_status_cancelled\">Cancelled</option>\n\t\t<option value=\"proposal_status_waiting\">Waiting</option>\n\t\t<option value=\"proposal_status_completed\">Completed</option>\n\t</optgroup>\n\t<optgroup label=\"Type of Proposal\">\n\t\t<option value=\"proposal_type_course\">Course</option>\n\t\t<option value=\"proposal_type_program\">Program</option>\n\t\t<option value=\"proposal_type_other\">Other</option>\n\t</optgroup>\t\n\t<option value=\"urgent\">Urgent Tasks</option>\n\t<option value=\"deadline\">Tasks with Deadlines</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterAllProposalsAdmin.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All Proposals</option>\n\t<optgroup label=\"Proposal Status\">\n\t\t<option value=\"proposal_status_reviewing\">Reviewing</option>\n\t\t<option value=\"proposal_status_active\">Active</option>\n\t\t<option value=\"proposal_status_held\">Held</option>\n\t\t<option value=\"proposal_status_suspended\">Suspended</option>\n\t\t<option value=\"proposal_status_cancelled\">Cancelled</option>\n\t\t<option value=\"proposal_status_waiting\">Waiting</option>\n\t\t<option value=\"proposal_status_completed\">Completed</option>\n\t</optgroup>\n\t<optgroup label=\"Type of Proposal\">\n\t\t<option value=\"proposal_type_course\">Course</option>\n\t\t<option value=\"proposal_type_program\">Program</option>\n\t\t<option value=\"proposal_type_other\">Other</option>\n\t</optgroup>\t";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterAllProposalsGuest.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All Proposals</option>\n\t<optgroup label=\"Proposal Status\">\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"id", env.opts.autoescape) > 0) {
output += "\n\t\t<option value=\"proposal_status_unlaunched\">Unlaunched</option>\n\t\t<option value=\"proposal_status_reviewing\">Reviewing</option>\n\t\t";
;
}
output += "\n\t\t<option value=\"proposal_status_active\">Active</option>\n\t\t<option value=\"proposal_status_held\">Held</option>\n\t\t<option value=\"proposal_status_suspended\">Suspended</option>\n\t\t<option value=\"proposal_status_cancelled\">Cancelled</option>\n\t\t<option value=\"proposal_status_waiting\">Waiting</option>\n\t\t<option value=\"proposal_status_completed\">Completed</option>\n\t</optgroup>\n\t<optgroup label=\"Type of Proposal\">\n\t\t<option value=\"proposal_type_course\">Course</option>\n\t\t<option value=\"proposal_type_program\">Program</option>\n\t\t<option value=\"proposal_type_other\">Other</option>\n\t</optgroup>\t";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterApproved.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All Approved</option>\n\t<option value=\"exported\">Exported</option>\n\t<option value=\"not-exported\">Waiting for Export</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterAttention.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"request\">Requests</option>\n\t<option value=\"held\">Held</option>\n\t<option value=\"suspended\">Suspended</option>\n\t<option value=\"stuck\">Stuck</option>\n\t<option value=\"reviewing\">Review</option>\n\t<option value=\"empty\">Current Step is Empty</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterMine.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All My Proposals</option>\n\t<optgroup label=\"Proposal Status\">\n\t\t<option value=\"proposal_status_unlaunched\">Unlaunched</option>\n\t\t<option value=\"proposal_status_reviewing\">Reviewing</option>\n\t\t<option value=\"proposal_status_active\">Active</option>\n\t\t<option value=\"proposal_status_held\">Held</option>\n\t\t<option value=\"proposal_status_suspended\">Suspended</option>\n\t\t<option value=\"proposal_status_cancelled\">Cancelled</option>\n\t\t<option value=\"proposal_status_waiting\">Waiting</option>\n\t</optgroup>\n\t<optgroup label=\"Type of Proposal\">\n\t\t<option value=\"proposal_type_course\">Course</option>\n\t\t<option value=\"proposal_type_program\">Program</option>\n\t\t<option value=\"proposal_type_other\">Other</option>\n\t</optgroup>\t\n\t<option value=\"urgent\">Urgent Tasks</option>\n\t<option value=\"deadline\">Tasks with Deadlines</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterTask.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All Tasks</option>\n\t<optgroup label=\"Proposal Status\">\n\t\t<option value=\"proposal_status_active\">Active</option>\n\t\t<option value=\"proposal_status_held\">Held</option>\n\t\t<option value=\"proposal_status_cancelled\">Cancelled</option>\n\t</optgroup>\n\t<optgroup label=\"Type of Proposal\">\n\t\t<option value=\"proposal_type_course\">Course</option>\n\t\t<option value=\"proposal_type_program\">Program</option>\n\t\t<option value=\"proposal_type_other\">Other</option>\n\t</optgroup>\t\n\t<option value=\"urgent\">Urgent Tasks</option>\n\t<option value=\"deadline\">Tasks with Deadlines</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalList/simpleFilterWatching.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\t<option value=\"proposal_title\">All Watch List</option>\n\t<optgroup label=\"Proposal Status\">\n\t\t<option value=\"proposal_status_active\">Active</option>\n\t\t<option value=\"proposal_status_held\">Held</option>\n\t\t<option value=\"proposal_status_suspended\">Suspended</option>\n\t\t<option value=\"proposal_status_cancelled\">Cancelled</option>\n\t\t<option value=\"proposal_status_waiting\">Waiting</option>\n\t</optgroup>\n\t<optgroup label=\"Type of Proposal\">\n\t\t<option value=\"proposal_type_course\">Course</option>\n\t\t<option value=\"proposal_type_program\">Program</option>\n\t\t<option value=\"proposal_type_other\">Other</option>\n\t</optgroup>\t\n\t<option value=\"urgent\">Urgent Tasks</option>\n\t<option value=\"deadline\">Tasks with Deadlines</option>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalToolbox/proposalLookupEmptyTitle.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"no-summary\" id=\"detail-0\">\n\t<h3 class=\"list-name no-results\" tabindex=\"0\">Enter a Proposal Title above to view related Proposals.</h3>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalToolbox/proposalLookupItem.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li\n\tclass=\"status-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += " proposal-lookup-summary\"\n\tid=\"detail-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" tabindex=\"0\" data-proposal-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  <div class=\"list-item-info\">\n    <h3 class=\"list-name\"\n      data-is-crosslisted=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape), env.opts.autoescape);
output += " tabindex=\"0\">\n      ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n      ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"isUrgent", env.opts.autoescape) && runtime.contextOrFrameLookup(context, frame, "level") != "admin") {
output += "<div class=\"list-name-img urgent\"><span class=\"screen-reader-text\">Urgent</span></div>";
;
}
output += "\n      ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"flag", env.opts.autoescape) == "stuck" && runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "<div class=\"list-name-img stuck\"><span class=\"screen-reader-text\">Stuck</span></div>";
;
}
output += "\n      ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape)) {
output += "<div class=\"list-name-img crosslisted tip\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslistedFamily", env.opts.autoescape), env.opts.autoescape);
output += "\"></div>";
;
}
output += "\n      ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape) == "completed") {
output += "<div class=\"list-name-img completed\"><span class=\"screen-reader-text\">Completed</span></div>";
;
}
output += "\n    </h3>\n    <dl class=\"list-details clearfix\">\n\n      <dt class=\"step-label\" tabindex=\"0\">Approval Process:</dt>\n      <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"approvalProcessName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n      <dt class=\"step-label\" tabindex=\"0\">Proposal Originator:</dt>\n      <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"originatorName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n      <dt class=\"step-label\" tabindex=\"0\">Status:</dt>\n      <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n      <dt tabindex=\"0\">Last Activity:</dt>\n      <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"date", env.opts.autoescape), env.opts.autoescape);
output += " by ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"user", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n    </dl>\n  </div>\n  <ul class=\"actions\">\n    <li>\n      <button tabindex=\"0\" type=\"button\" data-proposal-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-proposal-action tip\" name=\"preview-proposal-lookup\" title=\"Print\">\n        <span class=\"screen-reader-text\">Print</span>\n      </button>\n    </li>\n  </ul>\n  ";
;
}
else {
output += "\n  <h3 class=\"list-name\"\n    data-is-crosslisted=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape), env.opts.autoescape);
output += " tabindex=\"0\">\n    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"isUrgent", env.opts.autoescape) && runtime.contextOrFrameLookup(context, frame, "level") != "admin") {
output += "<div class=\"list-name-img urgent\"><span class=\"screen-reader-text\">Urgent</span></div>";
;
}
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"flag", env.opts.autoescape) == "stuck" && runtime.contextOrFrameLookup(context, frame, "level") == "admin") {
output += "<div class=\"list-name-img stuck\"><span class=\"screen-reader-text\">Stuck</span></div>";
;
}
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape)) {
output += "<div class=\"list-name-img crosslisted tip\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslistedFamily", env.opts.autoescape), env.opts.autoescape);
output += "\"></div>";
;
}
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape) == "completed") {
output += "<div class=\"list-name-img completed\"><span class=\"screen-reader-text\">Completed</span></div>";
;
}
output += "\n  </h3>\n  <ul class=\"actions\">\n    <li>\n      <button tabindex=\"0\" type=\"button\" data-proposal-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-proposal-action tip\" name=\"preview-proposal-lookup\" title=\"Print\">\n        <span class=\"screen-reader-text\">Print</span>\n        <img src=\"/images/icons/flat/print.png\" alt=\"\">\n      </button>\n    </li>\n  </ul>\n\n  <dl class=\"list-details clearfix\">\n\n    <dt class=\"step-label\" tabindex=\"0\">Approval Process:</dt>\n    <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"approvalProcessName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n    <dt class=\"step-label\" tabindex=\"0\">Proposal Originator:</dt>\n    <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"originatorName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n    <dt class=\"step-label\" tabindex=\"0\">Status:</dt>\n    <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n    <dt tabindex=\"0\">Last Activity:</dt>\n    <dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"date", env.opts.autoescape), env.opts.autoescape);
output += " by ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"user", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n  </dl>\n  ";
;
}
output += "\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalToolbox/proposalLookupLoading.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"no-summary\" id=\"detail-0\">\n\t<h3 class=\"list-name loading\" tabindex=\"0\">Retrieving Proposals</h3>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalToolbox/proposalLookupNoAccess.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"error-page clearfix\">\n\t<span id=\"blue-page-message\" tabindex=\"0\">You must be logged in to view proposals.</span>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalToolbox/proposalLookupNone.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<li class=\"no-summary\" id=\"detail-0\">\n\t<h3 class=\"list-name no-results\" tabindex=\"0\">No Proposals Found</h3>\n</li>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["ProposalToolbox/proposalLookupView.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"proposal-lookup-view-header\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n  <div class=\"list-item-info\">\n    <h2 class=\"list-name\"\n  \t\tdata-is-crosslisted=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape), env.opts.autoescape);
output += " tabindex=\"0\">\n  \t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n  \t<h3  tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"approvalProcessName", env.opts.autoescape), env.opts.autoescape);
output += "</h3>\n    <dl class=\"list-details clearfix\">\n  \t\t<dt class=\"step-label\" tabindex=\"0\">Proposal Originator:</dt>\n  \t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"originatorName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n  \t\t<dt class=\"step-label\" tabindex=\"0\">Status:</dt>\n  \t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n  \t\t<dt tabindex=\"0\">Last Activity:</dt>\n  \t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"date", env.opts.autoescape), env.opts.autoescape);
output += " by ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"user", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n  \t</dl>\n  </div>\n  <ul class=\"actions proposal-lookup-view-action-bar\">\n\t\t<li>\n\t\t\t<button tabindex=\"0\" type=\"button\" data-proposal-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-proposal-action tip\" name=\"preview-proposal-lookup\"  title=\"Print\">\n\t\t\t\t<span class=\"screen-reader-text\">Print</span>\n\t\t\t</button>\n    </li>\n    <li>\n\t\t\t<button tabindex=\"0\" type=\"button\" class=\"curriculog-proposal-action tip\" name=\"close-proposal-lookup-view\" title=\"Select Another Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Select Another Proposal</span>\n\t\t\t</button>\n\t\t</li>\n\t</ul>\n  ";
;
}
else {
output += "\n\t<h2 class=\"list-name\"\n\t\tdata-is-crosslisted=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"crosslisted", env.opts.autoescape), env.opts.autoescape);
output += " tabindex=\"0\">\n\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"name", env.opts.autoescape), env.opts.autoescape);
output += "\n\t<h3  tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"approvalProcessName", env.opts.autoescape), env.opts.autoescape);
output += "</h3>\n\t<ul class=\"actions proposal-lookup-view-action-bar\">\n\t\t<li>\n\t\t\t<button tabindex=\"0\" type=\"button\" data-proposal-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"id", env.opts.autoescape), env.opts.autoescape);
output += "\" class=\"curriculog-proposal-action tip\" name=\"preview-proposal-lookup\"  title=\"Print\">\n\t\t\t\t<span class=\"screen-reader-text\">Print</span>\n\t\t\t\t<img src=\"/images/icons/flat/print.png\" alt=\"\">\n\t\t\t</button>\n\t\t\t<button tabindex=\"0\" type=\"button\" class=\"curriculog-proposal-action tip\" name=\"close-proposal-lookup-view\" title=\"Select Another Proposal\">\n\t\t\t\t<span class=\"screen-reader-text\">Select Another Proposal</span>\n\t\t\t\t<img src=\"/images/icons/flat/proposal-lookup-close.png\" alt=\"\">\n\t\t\t</button>\n\t\t</li>\n\t</ul>\n\n\t<dl class=\"list-details clearfix\">\n\t\t<dt class=\"step-label\" tabindex=\"0\">Proposal Originator:</dt>\n\t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"originatorName", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n\t\t<dt class=\"step-label\" tabindex=\"0\">Status:</dt>\n\t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"status", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\n\t\t<dt tabindex=\"0\">Last Activity:</dt>\n\t\t<dd tabindex=\"0\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"date", env.opts.autoescape), env.opts.autoescape);
output += " by ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "proposal")),"lastModified", env.opts.autoescape)),"user", env.opts.autoescape), env.opts.autoescape);
output += "</dd>\n\t</dl>\n  ";
;
}
output += "\n</div>\n\n<div id=\"proposal-lookup-view-content\" class=\"curriculog-agenda-print diff\"></div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Settings/userImport.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<div id=\"summary-11\" class=\"summary active\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n    <div class=\"summary-content\">\n        <div class=\"summary-content-title\">\n          <h2 class=\"summary-title\">User Import</h2>\n          <button class=\"curriculog-widget close-widget close-summary\"><strong class=\"screen-reader-text\">Close</strong></button>\n        </div>\n    ";
;
}
else {
output += "\n    <div class=\"summary-toolbar\">\n        <h2 class=\"summary-heading\">User Import</h2>\n        <a href=\"#\" class=\"curriculog-widget close-widget close-summary\"><strong>Close</strong></a>\n    </div>\n    <div class=\"summary-content\">\n    ";
;
}
output += "\n        <h3 class=\"summary-title\">Select a file</h3>\n\n        <div class=\"summary-content\">\n          <fieldset>\n            <input type=\"file\" id=\"csv_file\" aria-label=\"Choose File\" accept=\".csv\">\n          </fieldset>\n        </div>\n      </div>\n      <div class=\"summary-content\">\n      <h3 class=\"summary-title\">Users to import</h3>\n\n        <div id=\"user-import-summary\" class=\"summary-content\">\n            <fieldset>\n                <table id=\"user-import-list\">\n                    <thead>\n                    <tr id=\"user-import-headers\">\n                        <td>First Name</td>\n                        <td>Last Name</td>\n                        <td>Email</td>\n                        <td>Password</td>\n                        <td>User name</td>\n                        <td></td>\n                    </tr>\n                    </thead>\n                    <tbody></tbody>\n                </table>\n                <button id=\"user-import-submit\" class=\"form-button\"><span>Import Users</span></button>\n            </fieldset>\n        </div>\n        <h4 id=\"import-loading-users\" class=\"summary-title\">Loading Existing Users...</h4>\n        <h4 id=\"user-import-parsing\" class=\"summary-title\">Parsing File...</h4>\n        <h4 id=\"user-import-save-status\" class=\"summary-title\">Saved OVER 9000 users</h4>\n    </div>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["Settings/userImportRow.html"] = (function() {function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "<tr class=\"user-import-row\">\n    <td class=\"first_name\"><input type=\"text\" /></td>\n    <td class=\"last_name\"><input type=\"text\" /></td>\n    <td class=\"email\"><input type=\"text\" /></td>\n    <td class=\"password\"><input type=\"password\" /></td>\n    <td class=\"username\"><input type=\"text\" /></td>\n    <td class=\"delete\"><button>\n      ";
if(runtime.contextOrFrameLookup(context, frame, "cui_enabled")) {
output += "\n      <span class=\"screen-reader-text\">Delete</span>\n      ";
;
}
else {
output += "\n      Delete\n      ";
;
}
output += "\n    </button></td>\n</tr>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};
})();
})();
